var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import globalStore from '../store';
import CustomScrollbar from './CustomScrollbar';
import BottomPanel from './BottomPanel';
import ContextMenu from './ContextMenu';
import BackgroundRenderer from './BackgroundRenderer';
import { resolvePageBackground } from '../middleware/jsonMiddleware';
import { announce } from '../helper/announcer';
import { useTranslation } from 'react-i18next';
import '../styles/whiteboard.scss';
// import '../widgets/popup/Clock/clocks.scss';
import { DataContext } from '../player/DataContext';
import { Fragment, useContext, useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { saveState } from '../helper/stateManagerHelper';
import { calculateTokenPosition } from '../helper/tokenDropHelper';
import { leftSideTools, } from '../interface/gameController';
import { SHAPE_BOUNDS } from '../widgets/patternShapesConstants';
import DrawCanvas from './DrawCanvas';
import RaphaelCanvas from './RaphaelCanvas';
import DomCanvas from './DomCanvas';
import BackgroundPatternCanvas from './BackgroundPatternCanvas';
import ResizerComponent from './ResizerComponent';
import TableManipulativeComp from './TableManipulativeComp';
import Shades from './Shades';
import { calculateBoxWithPaddingAndRotation, getContentLockArray, getCircleBoundingBox, getMinMax, isPointInPolygon, toNumber, } from '../helper/helper';
import { ColorEnum } from './ColorPicker';
import DiceManipulative from '../widgets/DiceManipulative';
import ButtonComponent from './ButtonComponent';
import customEventHandler from '../helper/customEvents';
import { browserDetect } from '../helper/browserDetect';
import ManipulativeGroup from '../widgets/ManipulativeGroup';
import MathEditor from './MathEditor';
import SelectionCanvas from './SelectionCanvas';
import SelectionLayer from './SelectionLayer';
import AnalogClock from '../widgets/popup/Clock/AnalogClock';
import Timer from '../widgets/popup/Clock/Timer';
import CardManipulative from '../widgets/cards/CardManipulative';
import NumberCharts from '../widgets/NumberCharts';
import * as htmlToImage from 'html-to-image';
import NumberFrames from '../widgets/NumberFrames';
import Counter from '../widgets/Counter';
import TrayCounter from '../widgets/TrayCounter';
import ArrayModel from '../widgets/ArrayModel';
import CoinsAndCountersManipulative from '../widgets/CoinsAndCountersManipulative';
import CoinsAndCountersGroupOverlay from '../widgets/CoinsAndCountersGroupOverlay';
import CoinsAndCountersLinkPicker from '../widgets/CoinsAndCountersLinkPicker';
import ColoredTiles from '../widgets/ColoredTiles';
import LinearPiece from '../widgets/LinearPiece';
import PatternShapesManipulative from '../widgets/PatternShapesManipulative';
import PatternShapesSelectionGroup from '../widgets/PatternShapesSelectionGroup';
import PatternStaticOutlineCohort from '../widgets/PatternStaticOutlineCohort';
import ProtractorManipulative from '../widgets/ProtractorManipulative';
import FractionTileManipulative from '../widgets/FractionTileManipulative';
import LinkingCubes from '../widgets/LinkingCubes';
import LinkingCubePicker from '../widgets/LinkingCubePicker';
import ColoredTilesCellPicker from '../widgets/ColoredTilesCellPicker';
import ColoredTilesLinkPicker from '../widgets/ColoredTilesLinkPicker';
import ColoredTilesSelectionGroup from '../widgets/ColoredTilesSelectionGroup';
import LinearPieceSnapPicker from '../widgets/LinearPieceSnapPicker';
import PatternShapeLinkPicker from '../widgets/PatternShapeLinkPicker';
import NumberAndMoneyPiecePicker from '../widgets/NumberAndMoneyPiecePicker';
import NumberAndMoneyPieceGroupPicker from '../widgets/NumberAndMoneyPieceGroupPicker';
import NumberAndMoneyPieceSelectionGroup from '../widgets/NumberAndMoneyPieceSelectionGroup';
import FractionTilesSelectionGroup from '../widgets/FractionTilesSelectionGroup';
import FractionTilesGroupPicker from '../widgets/FractionTilesGroupPicker';
import NumberRackManipulative from '../widgets/NumberRackManipulative';
import NumberAndMoneyPieceManipulative from '../widgets/NumberAndMoneyPieceManipulative';
import SpinnerManipulative from '../widgets/SpinnerManipulative';
import NumberLineManipulative from '../widgets/NumberLineManipulative';
import NumberLineJumpBar from '../widgets/NumberLineJumpBar';
import NumberLineCustomTick from '../widgets/NumberLineCustomTick';
import { GRID_SIZE, TOTAL_SVG_HEIGHT } from '../constants/numberLineConfig';
import { computePxPerUnit } from '../helper/numberLineHelper';
import Popup from './Popup';
import { withBusy } from '../helper/busyOverlay';
// html-to-image clones the DOM into an SVG <foreignObject>, which on iOS
// silently drops two kinds of layers: HTML <canvas> bitmaps (the freehand
// DrawCanvas strokes) and GPU-composited, imperatively-built SVG (the Raphael
// vector annotations). Those layers are excluded from the html-to-image pass
// (see CAPTURE_FILTER) and re-drawn here, deterministically, on top of the
// captured DOM image so the screenshot includes annotations + drawn lines.
var ANNOTATION_LAYER_CLASSES = ['raphealContainer', 'drawingCanvas', 'liveDrawingCanvas'];
/* ─── Screenshot: selection chrome ─────────────────────────────────────────
   A screenshot must show the workspace as saved, not as it is being worked
   on. These live inside `.mainHolder` but exist only to serve the current
   selection / an in-progress on-canvas picker, so `captureMainHolderScreenshot`
   drops them from the clone: resizer border + handles, the floating tool
   panel, rotate / drag handles, the lasso, and the keyboard group pickers. */
var SELECTION_CHROME_CLASSES = [
    'resizeHolder',
    'bottomPanelTool',
    'rotateHandle',
    'patternShapeRotateHandle',
    'patternShapeRotateLine',
    // Number Frames move / rotate handles + the accent leader line (painted with
    // `background-color`, which the color rules deliberately don't touch).
    'nfMoveHandle',
    'nfMoveHandleBtn',
    'nfRotateHandle',
    'nfRotateBtn',
    'nfRotateLine',
    'psSelectionGroup__rotateHandle',
    'psSelectionGroup__dragCircle',
    // Pattern Shapes multi-select centre dot (white fill + #293273 stroke — the
    // colour rules only match the #5063AE accent, so it survived them).
    'psCenterDot',
    'groupSelectFocusState',
    // The per-widget select badge (SelectFocusOverlay) — an affordance for
    // selecting the widget, shown while it is NOT selected, so it lands in the
    // capture of an idle board.
    'selectFocusState',
    'selectionLasso',
    'psSelectionGroup',
    'psSelectionGroup__boundingBox',
    'psSelectionGroup__spokes',
    'resizeHandle',
    // Table editing chrome — resize handles, row/column controls, the add-row /
    // add-column bar. Only in the DOM while the table is being edited.
    'resize-handle',
    'rowControlsContainer',
    'columnControlsContainer',
    'tableBottomUIWrapper',
    // The on-canvas math keypad renders inline (not portalled) for whiteboard
    // editors, so it is inside `.mainHolder` while a text / math box or a table
    // cell is being edited.
    'keypadWrapper',
    // On-canvas pickers, open only mid-interaction.
    'nmpPicker',
    'nmpGroupPicker',
    'ftGroupPicker',
    'psLinkPicker',
    'coloredTilesCellPicker',
    'coloredTilesLinkPicker',
    'linearPieceSnapPicker',
    'ccLinkPicker',
    'linkingCubePicker',
];
/* The accent (#5063AE) every widget paints its "I am selected" glow with —
   `box-shadow: 0 0 20px #5063AE` on the widget wrapper (Timer, AnalogClock,
   ArrayModel, ColoredTiles, NumberRacks, Cards, Table, NMP, NumberCharts,
   Shades), `filter: drop-shadow(…)` on the class-driven ones (counters, coins,
   linking cubes, number line, fraction tiles) and an SVG `stroke` on Pattern
   Shapes. Matching on the computed color covers all of them without enumerating
   ~43 widgets' markup. Both notations appear in computed values. */
var SELECTION_ACCENT_RGB = ['rgb(80, 99, 174)', 'rgba(80, 99, 174'];
/* Only ever matched against `box-shadow`, `filter` and SVG `stroke` — NEVER
   `border-color` or `outline`. The same accent is used for real content
   elsewhere (the table's `#5063ae` cell borders, the shade border, the
   Show-product frame), so widening the match to borders/outlines erases
   workspace content from the capture. */
var accentMatches = function (value) {
    return !!value && SELECTION_ACCENT_RGB.some(function (c) { return value.includes(c); });
};
/* The app's focus-ring colors: `--focus-outline-color` (main.scss), the amber
   fallback some widgets hard-code, and the blue used by the pattern-shape /
   coins handles. Only used to recognise a focus ring painted on an ANCESTOR of
   the focused element (`:focus-within` / `:has(:focus-visible)`), so a content
   outline on that ancestor is left alone. */
var FOCUS_RING_RGB = ['rgb(225, 107, 0)', 'rgb(255, 152, 0)', 'rgb(0, 95, 204)'];
/* Group bounding boxes: a selection-only border, drawn in a neutral or accent
   color, on an overlay that carries no workspace content. Matched by class
   because the color rule deliberately ignores borders. */
var SELECTION_OUTLINE_CLASSES = [
    'ccGroupOutline',
    'coloredTilesSelectionGroup',
    'numberAndMoneyPieceSelectionGroup',
];
/* ─── Screenshot: selection state MODIFIER classes ──────────────────────────
   Widgets that paint "I am selected" in the dark navy #293273 — a different
   colour from the #5063AE accent — or on a property the colour rules
   deliberately leave alone (`border-color` and `outline` are real content
   elsewhere: table cell borders, the shade border, the dollar bill's green edge,
   the ColoredTiles outer grid border). A blanket border/outline rule was tried
   and it erased that content, so these are targeted per widget instead.

   These are **removed from the live DOM for the duration of the capture and
   restored afterwards**, rather than being overridden with a replacement value.
   That matters because most of them are *modifiers* on an element that also
   carries real styling: `.pattern-shape--selected` only overrides the
   `border-color` and `box-shadow` that `.pattern-shape` already sets, so
   forcing `borderColor: transparent` would erase the base border too, and
   forcing `boxShadow: none` would drop the base `$shadow-soft`. Dropping the
   modifier class restores the unselected appearance exactly, with no value to
   guess or keep in sync. */
var SELECTION_STATE_CLASSES = [
    // .linearPieceWidget.selected → border: 2px solid #293273
    'selected',
    // .pattern-shape--selected → border-color + a 3px rgba(59,130,246,.25) ring
    'pattern-shape--selected',
    // .shadeContainer.shadeSelected .shades → box-shadow halo rgba(41,50,115,.4)
    'shadeSelected',
    // Protractor: inline `border: 2px solid #293273` while focused (the #5063AE
    // glow beside it is already suppressed, so the dark ring was all that was
    // left). The marker class exists only so the capture can find it.
    'protractorSelected',
    // Table: `inset 0 0 0 2px #293273` on a selected cell (`.tableManipTd.cellSelected`).
    // The cell's own `#5063ae` grid border must survive, which is exactly why
    // this is a class removal and not a border/box-shadow override.
    'cellSelected',
];
/* `selected` is a very common modifier name — plenty of elements carry it for
   reasons that have nothing to do with a capture. It is therefore dropped ONLY
   from elements matching this selector; every other name in
   `SELECTION_STATE_CLASSES` is specific enough to drop unscoped. */
var GENERIC_STATE_CLASS_SCOPE = {
    selected: '.linearPieceWidget',
};
/* Elements whose `outline` is a selection affordance and never content. The
   card's focus ring is an inline `outline: 1px solid rgb(40,50,115)` on the card
   artwork itself, so it cannot be dropped by class — the element IS the picture.
   Its unfocused value is `1px solid transparent`, so clearing the outline is a
   visual no-op when nothing is focused. */
var SELECTION_OUTLINE_ONLY_SELECTORS = ['.frontCardImg', '.backCardImg'];
var loadImageEl = function (src) {
    return new Promise(function (resolve, reject) {
        var im = new Image();
        im.onload = function () { return resolve(im); };
        im.onerror = reject;
        im.src = src;
    });
};
/* Load the clone SVG and wait for it to be genuinely paintable: `onload` fires
   as soon as the SVG document is parsed, which for a `<foreignObject>` clone is
   long before the raster images nested inside it (`data:image/png;…`) have
   decoded. `decode()` + one frame is the closest the platform gets to "ready",
   and it is still not sufficient on WebKit — see rasterizeCloneSvg. */
var loadCloneSvg = function (src) {
    return new Promise(function (resolve, reject) {
        var im = new Image();
        im.decoding = 'async';
        im.onload = function () {
            var paint = function () { return requestAnimationFrame(function () { return resolve(im); }); };
            // `decode` is missing on older iPadOS Safari (and in jsdom), where calling
            // it would throw synchronously inside this handler — leaving the promise
            // forever unsettled, which `captureInFlightRef` would then latch as the
            // shared in-flight capture for the rest of the session. A failed decode is
            // not fatal either: the raster pass below measures what actually painted,
            // so fall through in every case.
            if (typeof im.decode !== 'function')
                return paint();
            try {
                im.decode().then(paint, paint);
            }
            catch (_a) {
                paint();
            }
        };
        im.onerror = reject;
        im.src = src;
    });
};
/* Rasterise the `<foreignObject>` clone SVG to a PNG data URL, repeating until
   two consecutive passes agree.

   WHY THE REPEAT IS NOT OPTIONAL (the iPad bug this exists for): WebKit paints
   its FIRST raster of a freshly-built clone SVG *without* the raster images
   nested inside it — they have not been decoded yet, and nothing in the image
   load/decode contract waits for a `<foreignObject>` subtree's own
   subresources. The result is a real-looking, many-hundred-KB PNG in which
   every widget whose art is a PNG has silently vanished: the analog clock face
   (`number_clock.png`) and the dice body sprite were the reported casualties.
   Once WebKit has decoded those bitmaps AT THIS RASTER SIZE it caches them, so
   the second pass paints complete and every later pass is byte-identical.

   Measured in WebKit on a 1500×1500 board at pixelRatio 2: pass 1 = 80 ms and
   missing the clock face, pass 2 = 23 ms and complete, passes 3-4 = 4-9 ms and
   identical. Chromium is complete from pass 1 and simply confirms on pass 2.

   The clone is built ONCE by the caller and only the raster repeats — that is
   what makes this affordable. The previous implementation called
   `htmlToImage.toPng` up to 4 times, re-cloning and re-embedding the whole DOM
   (~540 ms of each ~800 ms pass) on every attempt.

   The oracle is the encoded byte length: a pass that painted more content
   encodes to a different size. It is deliberately NOT "does this look big
   enough" — the broken iPad capture was 173 KB, which sailed past the old
   `> 5000 bytes` blank-PNG check and is exactly why the bug shipped. (That same
   5 KB number does still appear below, as MIN_PLAUSIBLE_PNG_BYTES — for the
   different question of whether a pass produced an image at all. Read the note
   there before assuming the check came back.) */
var RASTER_PASS_LIMIT = 4;
/* DEGENERACY vs COMPLETENESS — two different questions, two different tests.
   Conflating them has now caused a bug in both directions, so keep them apart.

   A PNG this small cannot be a real board (a plain white 4096² canvas still
   encodes to tens of KB). iOS hands back a blank or 1×1 canvas when it cannot
   allocate the backing store, which shows up here as a ~163-byte data URL —
   observed on a physical iPad. Such a pass is not evidence of anything and must
   NOT feed the convergence oracle: two blank passes have *equal* byte length,
   which the oracle would read as "stable" and return, saving a blank PNG.

   Note the symmetry with the original bug: the old code used this same 5 KB
   number as a COMPLETENESS test, where it was useless (the incomplete capture
   was 173 KB). Here it is only ever a DEGENERACY test — "did this pass produce
   an image at all" — and completeness is still decided by comparing two passes
   to each other. */
var MIN_PLAUSIBLE_PNG_BYTES = 5000;
/* Hard per-dimension canvas limit. The caller's SAFARI_MAX_PIXELS cap bounds the
   total AREA, which still permits a single dimension over the limit on an
   extremely wide or tall board (20000 × 800 is under 16M px). A canvas past this
   is silently unusable, so scale both axes down together — keeping the aspect
   ratio — exactly as html-to-image's own `toCanvas` used to do for us before the
   raster moved in here. */
var MAX_CANVAS_DIMENSION = 16384;
var rasterizeCloneSvg = function (svgUrl, width, height, pixelRatio, backgroundColor) { return __awaiter(void 0, void 0, void 0, function () {
    var canvasWidth, canvasHeight, longest, scale, canvas, ctx, best, previous, current, pass, im, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                canvasWidth = Math.max(1, Math.round(width * pixelRatio));
                canvasHeight = Math.max(1, Math.round(height * pixelRatio));
                longest = Math.max(canvasWidth, canvasHeight);
                if (longest > MAX_CANVAS_DIMENSION) {
                    scale = MAX_CANVAS_DIMENSION / longest;
                    canvasWidth = Math.max(1, Math.round(canvasWidth * scale));
                    canvasHeight = Math.max(1, Math.round(canvasHeight * scale));
                }
                canvas = document.createElement('canvas');
                canvas.width = canvasWidth;
                canvas.height = canvasHeight;
                ctx = canvas.getContext('2d');
                if (!ctx)
                    return [2 /*return*/, ''];
                best = '';
                previous = '';
                current = '';
                _a.label = 1;
            case 1:
                _a.trys.push([1, , 6, 7]);
                pass = 0;
                _a.label = 2;
            case 2:
                if (!(pass < RASTER_PASS_LIMIT)) return [3 /*break*/, 5];
                return [4 /*yield*/, loadCloneSvg(svgUrl)];
            case 3:
                im = _a.sent();
                // Repaint the background every pass — the canvas is reused, so last pass's
                // pixels are still on it.
                ctx.fillStyle = backgroundColor;
                ctx.fillRect(0, 0, canvasWidth, canvasHeight);
                ctx.drawImage(im, 0, 0, canvasWidth, canvasHeight);
                result = canvas.toDataURL();
                // A degenerate pass proves nothing — don't let it converge (see
                // MIN_PLAUSIBLE_PNG_BYTES). Retry; if every pass is degenerate we return
                // '' and the caller decides how to recover.
                if (result.length < MIN_PLAUSIBLE_PNG_BYTES)
                    return [3 /*break*/, 4];
                previous = current;
                current = result;
                if (current.length > best.length)
                    best = current;
                if (previous && previous.length === current.length)
                    return [3 /*break*/, 5];
                _a.label = 4;
            case 4:
                pass++;
                return [3 /*break*/, 2];
            case 5: return [3 /*break*/, 7];
            case 6:
                // Hand the backing store back before compositeAnnotationLayers allocates a
                // full-size canvas of its own — on iOS the two together are what exhaust it.
                canvas.width = 1;
                canvas.height = 1;
                return [7 /*endfinally*/];
            case 7: return [2 /*return*/, best];
        }
    });
}); };
var compositeAnnotationLayers = function (mainHolder, baseDataUrl, width, height, pixelRatio) { return __awaiter(void 0, void 0, void 0, function () {
    var out, ctx_1, holderRect_1, rectOf_1, base, svg, clone, svgStr, url, svgImg, r, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 9, , 10]);
                out = document.createElement('canvas');
                out.width = Math.max(1, Math.round(width * pixelRatio));
                out.height = Math.max(1, Math.round(height * pixelRatio));
                ctx_1 = out.getContext('2d');
                if (!ctx_1)
                    return [2 /*return*/, baseDataUrl];
                holderRect_1 = mainHolder.getBoundingClientRect();
                rectOf_1 = function (el) {
                    var r = el.getBoundingClientRect();
                    return {
                        x: (r.left - holderRect_1.left) * pixelRatio,
                        y: (r.top - holderRect_1.top) * pixelRatio,
                        w: r.width * pixelRatio,
                        h: r.height * pixelRatio,
                    };
                };
                return [4 /*yield*/, loadImageEl(baseDataUrl)];
            case 1:
                base = _c.sent();
                ctx_1.drawImage(base, 0, 0, out.width, out.height);
                svg = mainHolder.querySelector('.raphealContainer svg');
                if (!svg) return [3 /*break*/, 8];
                _c.label = 2;
            case 2:
                _c.trys.push([2, 7, , 8]);
                clone = svg.cloneNode(true);
                if (!clone.getAttribute('xmlns')) {
                    clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
                }
                svgStr = new XMLSerializer().serializeToString(clone);
                url = URL.createObjectURL(new Blob([svgStr], { type: 'image/svg+xml' }));
                _c.label = 3;
            case 3:
                _c.trys.push([3, , 5, 6]);
                return [4 /*yield*/, loadImageEl(url)];
            case 4:
                svgImg = _c.sent();
                r = rectOf_1(svg);
                ctx_1.drawImage(svgImg, r.x, r.y, r.w, r.h);
                return [3 /*break*/, 6];
            case 5:
                URL.revokeObjectURL(url);
                return [7 /*endfinally*/];
            case 6: return [3 /*break*/, 8];
            case 7:
                _a = _c.sent();
                return [3 /*break*/, 8];
            case 8:
                // 3. Freehand strokes — draw the <canvas> bitmaps directly (same origin,
                //    so this never taints the output canvas).
                mainHolder.querySelectorAll('canvas.drawingCanvas, canvas.liveDrawingCanvas').forEach(function (c) {
                    var canvasEl = c;
                    if (!canvasEl.width || !canvasEl.height)
                        return;
                    var r = rectOf_1(canvasEl);
                    try {
                        ctx_1.drawImage(canvasEl, r.x, r.y, r.w, r.h);
                    }
                    catch (_a) {
                        // Skip a canvas that can't be drawn (e.g. tainted).
                    }
                });
                return [2 /*return*/, out.toDataURL('image/png')];
            case 9:
                _b = _c.sent();
                // On any failure fall back to the DOM-only capture.
                return [2 /*return*/, baseDataUrl];
            case 10: return [2 /*return*/];
        }
    });
}); };
var WhiteBoard = function (props) {
    var t = useTranslation().t;
    var whiteboardRef = useRef(null);
    var mainBoardRef = useRef(null);
    var _a = globalStore.useStoreState(function (store) { return store.playerStore; }), zoomLevel = _a.zoomLevel, canvasHeight = _a.canvasHeight, canvasWidth = _a.canvasWidth, displayMode = _a.displayMode, gameLoaded = _a.gameLoaded, pageData = _a.pageData, currentPage = _a.currentPage, language = _a.language, activityMeta = _a.activityMeta;
    var _b = globalStore.useStoreState(function (store) { return store.jsonDataStore; }), btnConfigJSON = _b.bottomToolConfig, btnConfig = _b.btnConfig;
    var _c = useContext(DataContext), tool = _c.tool, drawCommands = _c.drawCommands, setDrawCommands = _c.setDrawCommands, text = _c.text, setText = _c.setText, table = _c.table, annotations = _c.annotations, selectedTool = _c.selectedTool, shades = _c.shades, recenterPan = _c.recenterPan, panningEnable = _c.panningEnable, setPanningEnable = _c.setPanningEnable, color = _c.color, thickness = _c.thickness, manipulative = _c.manipulative, setManipulative = _c.setManipulative, setSelectedTool = _c.setSelectedTool, recenterPanOffset = _c.recenterPanOffset, setRecenterPanOffset = _c.setRecenterPanOffset, setContextMenu = _c.setContextMenu;
    var _d = useState(false), dragStarted = _d[0], setDragStarted = _d[1];
    var _e = useState([]), toolBtn = _e[0], setToolBtn = _e[1];
    var _f = useState(false), hideBottomBar = _f[0], setHideBottomBar = _f[1];
    var _g = useState(false), isDraggingState = _g[0], setIsDraggingState = _g[1];
    var _h = useState(null), activeLink = _h[0], setActiveLink = _h[1];
    var _j = useState(false), showRemoveLinkConfirm = _j[0], setShowRemoveLinkConfirm = _j[1];
    var _k = useState(null), selectionDim = _k[0], setSelectionDim = _k[1];
    var _l = useState(null), completedSelection = _l[0], setCompletedSelection = _l[1];
    var _m = useState(null), tableToolbarPosOverride = _m[0], setTableToolbarPosOverride = _m[1];
    var _o = useState(false), mathKeyboardVisible = _o[0], setMathKeyboardVisible = _o[1];
    var isDragging = useRef(false);
    var last = useRef({ x: 0, y: 0 });
    var scrollRef = useRef(null);
    var wrapperDiv = useRef(null);
    var prevZoomRef = useRef(zoomLevel);
    // While true, the view auto-recenters as the layout settles (panel mount,
    // zoom-fit, fullscreen, orientation). Flipped off the first time the user
    // pans so we never fight an intentional reposition.
    var autoCenterRef = useRef(true);
    // Ref for DrawCanvas to access live canvas directly
    var drawCanvasRef = useRef(null);
    // Live drawing refs - bypass React state for performance
    var livePointsRef = useRef([]);
    var lastPointRef = useRef(null);
    var rafIdRef = useRef(null);
    // Cache bounding rect to avoid layout thrashing on every mouse move
    var cachedRectRef = useRef(null);
    var cachedScaleRef = useRef({ scaleX: 1, scaleY: 1 });
    // Refs to avoid re-creating event listeners on every state change
    var drawCommandsRef = useRef(drawCommands);
    var selectionDimRef = useRef(selectionDim);
    var dragStartedRef = useRef(dragStarted);
    var toolRef = useRef(tool);
    var colorRef = useRef(color);
    var thicknessRef = useRef(thickness);
    var panningEnableRef = useRef(panningEnable);
    var selectedToolRef = useRef(selectedTool);
    var manipulativeRef = useRef(manipulative);
    var annotationsRef = useRef(annotations);
    var textRef = useRef(text);
    var tableRef = useRef(table);
    var shadesRef = useRef(shades);
    var liveStrokeRef = useRef(null);
    // Keep refs in sync with state - combined into single effect for better performance
    useEffect(function () {
        drawCommandsRef.current = drawCommands;
        selectionDimRef.current = selectionDim;
        dragStartedRef.current = dragStarted;
        toolRef.current = tool;
        colorRef.current = color;
        thicknessRef.current = thickness;
        panningEnableRef.current = panningEnable;
        selectedToolRef.current = selectedTool;
        manipulativeRef.current = manipulative;
        annotationsRef.current = annotations;
        textRef.current = text;
        tableRef.current = table;
        shadesRef.current = shades;
    }, [
        drawCommands,
        selectionDim,
        dragStarted,
        tool,
        color,
        thickness,
        panningEnable,
        selectedTool,
        manipulative,
        annotations,
        text,
        table,
        shades,
    ]);
    useEffect(function () {
        return function () {
            setDrawCommands([]);
            setSelectionDim(null);
            setDragStarted(false);
            setIsDraggingState(false);
            setActiveLink(null);
            setSelectedTool([]);
        };
    }, []);
    // Listen for real-time table toolbar position updates (during drag/resize)
    useEffect(function () {
        var handler = function (data) {
            setTableToolbarPosOverride(data);
        };
        customEventHandler.addEventListener('tableToolbarPosition', handler);
        return function () {
            customEventHandler.removeEventListener('tableToolbarPosition', handler);
        };
    }, []);
    // Helper function to check if text content is empty
    var isTextContentEmpty = useCallback(function (textData) {
        var _a;
        var content = (_a = textData === null || textData === void 0 ? void 0 : textData.data) === null || _a === void 0 ? void 0 : _a.text;
        if (!content)
            return true;
        // If content is a string, check if it's empty or only whitespace
        if (typeof content === 'string') {
            return content.trim().length === 0;
        }
        // If content is an array (MathEditor format), check each item
        if (Array.isArray(content)) {
            var WHITESPACE_CHAR_1 = '\u200B';
            var hasContent = content.some(function (item) {
                var _a;
                if (item.type === 'text') {
                    // Check if text value has meaningful content (not just whitespace chars)
                    var value = item.value || '';
                    var cleanedValue = value.replace(new RegExp("".concat(WHITESPACE_CHAR_1, "+"), 'g'), '').trim();
                    return cleanedValue.length > 0;
                }
                if (item.type === 'math') {
                    // Check if math latex has content
                    return item.latex && item.latex.trim().length > 0;
                }
                if (item.type === 'html') {
                    // Check if html has meaningful content
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = item.value || '';
                    return ((_a = tempDiv.textContent) === null || _a === void 0 ? void 0 : _a.trim().length) !== 0;
                }
                return false;
            });
            return !hasContent;
        }
        return true;
    }, []);
    // Effect to remove empty text boxes
    useEffect(function () {
        // Add delay to allow MathEditor's setText to complete
        var timeoutId = setTimeout(function () {
            // Check all text boxes and remove if empty
            var indicesToRemove = [];
            text.forEach(function (textItem, index) {
                // Only check text boxes that are not currently selected
                var isSelected = selectedTool.some(function (tool) {
                    return tool === "text_".concat(index) || tool === "newMath_".concat(index) || tool === "mathtext_".concat(index);
                });
                if (!isSelected && isTextContentEmpty(textItem)) {
                    indicesToRemove.push(index);
                }
            });
            if (indicesToRemove.length > 0) {
                // Sort in descending order to remove from end first (preserves indices)
                indicesToRemove.sort(function (a, b) { return b - a; });
                setText(function (prev) {
                    var newText = __spreadArray([], prev, true);
                    indicesToRemove.forEach(function (index) {
                        newText.splice(index, 1);
                    });
                    return newText;
                });
            }
        }, 600);
        // Cleanup timeout on unmount or when dependencies change
        return function () { return clearTimeout(timeoutId); };
    }, [selectedTool, text, isTextContentEmpty, setText]);
    // Save state when drawing is completed (dragStarted changes from true to false)
    var prevDragStartedRef = useRef(dragStarted);
    useEffect(function () {
        // If dragStarted changed from true to false, drawing was just completed
        if (prevDragStartedRef.current === true && dragStarted === false) {
            // Save the last draw command if it exists and has points
            if (drawCommands.length > 0) {
                var lastCommand = drawCommands[drawCommands.length - 1];
                if (lastCommand && lastCommand.points.length > 0) {
                    saveState({
                        type: 'drawCommand',
                        id: drawCommands.length - 1,
                        propertyName: 'create',
                        old: JSON.stringify(lastCommand),
                    });
                }
            }
        }
        prevDragStartedRef.current = dragStarted;
    }, [dragStarted, drawCommands]);
    var manipulativeMerged = useMemo(function () {
        var groupMap = {};
        var firstIndexMap = {};
        // Build grouping maps
        manipulative.forEach(function (item, index) {
            if (!item || !item.data)
                return;
            var gid = item.data.groupId;
            if (!gid)
                return;
            if (!groupMap[gid]) {
                groupMap[gid] = [];
                firstIndexMap[gid] = index;
            }
            groupMap[gid].push(item);
        });
        var result = [];
        var usedGroups = new Set();
        manipulative.forEach(function (item, index) {
            if (!item || !item.data)
                return;
            var gid = item.data.groupId;
            if (!gid) {
                result.push(item);
                return;
            }
            // Pattern shapes stay as individual items — group overlay handles interaction
            if (item.data.type === 'patternShapes') {
                result.push(item);
                return;
            }
            // NMP pieces stay as individual items — group drag handled within the component
            if (item.data.type === 'numberPiece' || item.data.type === 'moneyPiece') {
                result.push(item);
                return;
            }
            // ColoredTiles stay as individual items — group drag handled within the component (same as NMP)
            if (item.data.type === 'coloredTiles') {
                result.push(item);
                return;
            }
            // LinearPiece participates in the coloredTiles group flow — keep individual,
            // coordinate via shared groupId on multiSelectMove.
            if (item.data.type === 'linearPiece') {
                result.push(item);
                return;
            }
            // Coins & Counters stay as individual items — group drag is handled
            // inside CoinsAndCountersManipulative.onPointerDown (drag any group
            // member moves all). Without this exemption, grouped coins would be
            // merged into a `type:'group'` aggregate and rendered by
            // <ManipulativeGroup>, which lays members out for NMP/Dice and
            // therefore (a) hides the original coin renders and (b) overwrites
            // their centers — leaving them collapsed on ungroup.
            if (item.data.type === 'coinsAndCounters') {
                result.push(item);
                return;
            }
            // Fraction tiles stay as individual items — same convention as NMP/
            // patternShapes: group drag/selection is handled by the sibling
            // FractionTilesSelectionGroup overlay, not by <ManipulativeGroup>.
            if (item.data.type === 'fractionTiles') {
                result.push(item);
                return;
            }
            // first occurrence of this group
            if (!usedGroups.has(gid) && firstIndexMap[gid] === index) {
                var sortedMembers = groupMap[gid].sort(function (a, b) { var _a, _b; return ((_a = a.data.groupPosition) !== null && _a !== void 0 ? _a : 0) - ((_b = b.data.groupPosition) !== null && _b !== void 0 ? _b : 0); });
                result.push({
                    type: 'group',
                    groupId: gid,
                    data: sortedMembers,
                });
                usedGroups.add(gid);
            }
        });
        return result;
    }, [manipulative]);
    // Scroll the canvas so it sits centered in the viewport. Measured against
    // the live viewport size, so it must run *after* layout has reflowed.
    var centerView = useCallback(function () {
        var container = whiteboardRef.current;
        var scroll = scrollRef.current;
        if (!container || !scroll)
            return;
        var scaledW = canvasWidth * zoomLevel;
        var scaledH = canvasHeight * zoomLevel;
        var left = Math.max(0, Math.round((scaledW - container.clientWidth) / 2));
        var top = Math.max(0, Math.round((scaledH - container.clientHeight) / 2));
        scroll.scrollLeft = left;
        scroll.scrollTop = top;
        setRecenterPanOffset({ x: left, y: top });
        prevZoomRef.current = zoomLevel;
    }, [zoomLevel, canvasWidth, canvasHeight, setRecenterPanOffset]);
    // Center on mount, zoom changes, recenter, or canvas dimension changes.
    // Deferred a frame so the measurement reflects the post-change layout.
    useEffect(function () {
        if (!gameLoaded)
            return;
        var id = requestAnimationFrame(function () { return centerView(); });
        return function () { return cancelAnimationFrame(id); };
    }, [zoomLevel, recenterPan, canvasWidth, canvasHeight, gameLoaded, centerView]);
    // Pressing the recenter button re-enables auto-centering.
    useEffect(function () {
        autoCenterRef.current = true;
    }, [recenterPan]);
    // The viewport keeps settling for a beat after `gameLoaded` (the right-side
    // panel mounts, zoom-fit runs, fonts/fullscreen reflow). A single center on
    // load therefore lands inconsistently. Re-center on every viewport resize
    // until the user pans, so saved states always open centered.
    useEffect(function () {
        var container = whiteboardRef.current;
        if (!container || !gameLoaded)
            return;
        var rafId = null;
        var ro = new ResizeObserver(function () {
            if (!autoCenterRef.current)
                return;
            if (rafId)
                cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(function () { return centerView(); });
        });
        ro.observe(container);
        return function () {
            ro.disconnect();
            if (rafId)
                cancelAnimationFrame(rafId);
        };
    }, [gameLoaded, centerView]);
    // Memoize getXYScaled to avoid recreation on every render
    var getXYScaled = useCallback(function (e) {
        var clientX = 'clientX' in e ? e.clientX : e.touches[0].clientX;
        var clientY = 'clientY' in e ? e.clientY : e.touches[0].clientY;
        if (mainBoardRef.current) {
            var rect = mainBoardRef.current.getBoundingClientRect();
            var scaleX = canvasWidth / rect.width; // relationship bitmap : element
            var scaleY = canvasHeight / rect.height;
            var x = (clientX - rect.left) * scaleX;
            var y = (clientY - rect.top) * scaleY;
            return { x: x, y: y };
        }
        return { x: 0, y: 0 };
    }, [canvasWidth, canvasHeight]);
    useEffect(function () {
        var _a, _b;
        var mouseDown = function (e) {
            var _a, _b, _c, _d;
            var target = e.target;
            // Universal check: Is this a naturally interactive element?
            var isInteractive = !!(target.tagName === 'BUTTON' ||
                target.tagName === 'INPUT' ||
                target.tagName === 'TEXTAREA' ||
                target.tagName === 'SELECT' ||
                target.tagName === 'A' ||
                target.closest('button, input, textarea, select, a, [role="button"], [contenteditable="true"]') ||
                target.isContentEditable);
            var clientX = 'clientX' in e ? e.clientX : e.touches[0].clientX;
            var clientY = 'clientY' in e ? e.clientY : e.touches[0].clientY;
            var clearedSelection = false;
            var hasSelection = selectedToolRef.current.length > 0;
            var isClickOnMainBoard = (_b = (_a = mainBoardRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) !== null && _b !== void 0 ? _b : false;
            var isOverManipulative = !!(target.closest('.patternShapeWrapper, .psSelectionGroup, .manipulativeGroup, .diceWrapper, .spinnerManipulativeWrapper, .cardPoolWrapper, .cardWrapperPerspective, .cardWrapper, .shadeContainer, .shades, .counter, .numberRackWrapper, .tableManipContainer, .fraction-tile-manipulative, .numberLineWidget, .jumpBarManipulative, .numberLineCustomTickManipulative, .coloredTilesWrapper, .coloredTilesSelectionGroup, .linearPieceSnapPicker, .analog_clockHolder, .timer-wrapper, .arrayModelWrapper, .numberFramesWidget, .linearPieceWidget, .protractorWrapper, .protractorContainer, .coinsAndCountersWrapper, .ccGroupOutline') ||
                (target.closest('.raphaelCanvas') &&
                    target instanceof SVGElement &&
                    target.tagName !== 'svg'));
            // Don't clear selection when clicking on resizeHolder handles (drag/scale controls)
            var isOverResizeHolder = !!target.closest('.resizeHolder');
            // Defensive: a Shift / Ctrl / Cmd + click is an explicit multi-select
            // gesture. Never clear here on those — the manipulative's own click
            // handler will route through `selectTool()` and merge correctly. Without
            // this guard, WhiteBoard's mousedown can race ahead of the manipulative
            // (event bubbles up) and wipe the prior selection, so the helper sees
            // an empty array and the gesture degrades to single-select.
            var isMultiSelectGesture = e.shiftKey || e.ctrlKey || e.metaKey;
            var willDeselect = hasSelection &&
                isClickOnMainBoard &&
                !isOverManipulative &&
                !isInteractive &&
                !isOverResizeHolder &&
                !isMultiSelectGesture;
            if (hasSelection) {
                // eslint-disable-next-line no-console
                console.log('[ResizeHolderDrag debug] WhiteBoard mousedown deselect guard', JSON.stringify({
                    target: "".concat((_c = target === null || target === void 0 ? void 0 : target.tagName) !== null && _c !== void 0 ? _c : '', ".").concat(typeof (target === null || target === void 0 ? void 0 : target.className) === 'string' ? target.className : ''),
                    isClickOnMainBoard: isClickOnMainBoard,
                    isOverManipulative: isOverManipulative,
                    isInteractive: isInteractive,
                    isOverResizeHolder: isOverResizeHolder,
                    isMultiSelectGesture: isMultiSelectGesture,
                    selectedTool: __spreadArray([], selectedToolRef.current, true),
                    willDeselect: willDeselect,
                }));
            }
            if (willDeselect) {
                setSelectedTool([]);
                clearedSelection = true;
            }
            if (panningEnableRef.current) {
                // Prevent default for panning to avoid scrolling (but not on interactive elements)
                if ('touches' in e && !isInteractive)
                    e.preventDefault();
                isDragging.current = true;
                setIsDraggingState(true);
                last.current = { x: clientX, y: clientY };
            }
            else if ([leftSideTools.pen, leftSideTools.highlighter, leftSideTools.eraser].includes(toolRef.current) &&
                ((_d = e.target) === null || _d === void 0 ? void 0 : _d.classList.contains('drawingCanvas'))) {
                // Prevent default for drawing to avoid text selection
                if ('touches' in e && !isInteractive)
                    e.preventDefault();
                setDragStarted(true);
                // Initialize live drawing refs - NO React state updates during drawing
                livePointsRef.current = [];
                lastPointRef.current = null;
                liveStrokeRef.current = {
                    color: ColorEnum[colorRef.current],
                    points: [],
                    style: toolRef.current,
                    thickness: thicknessRef.current,
                };
                // Cache bounding rect once at start of drawing (avoid layout thrashing)
                if (mainBoardRef.current) {
                    cachedRectRef.current = mainBoardRef.current.getBoundingClientRect();
                    cachedScaleRef.current = {
                        scaleX: canvasWidth / cachedRectRef.current.width,
                        scaleY: canvasHeight / cachedRectRef.current.height,
                    };
                }
            }
            else if (toolRef.current === leftSideTools.selection && mainBoardRef.current) {
                // selectionDim start is handled by SelectionLayer's own onMouseDown handler
                // Only handle deselection here when items are selected and user clicks on empty space
                if (isClickOnMainBoard && !clearedSelection && selectedToolRef.current.length > 0) {
                    var target_1 = e.target;
                    // Don't deselect if clicking on a pattern shape SVG or other interactive element
                    if (target_1.tagName === 'CANVAS' ||
                        target_1.classList.contains('drawingCanvas') ||
                        target_1 === mainBoardRef.current) {
                        setSelectedTool([]);
                    }
                }
            }
            else if ('touches' in e && !isInteractive) {
                // Prevent unwanted touch behaviors (selection, drag) on canvas/non-interactive areas
                // but allow interactive elements (buttons, inputs) to work normally
                e.preventDefault();
            }
            // Selection start is now handled by SelectionLayer component
        };
        var mouseMove = function (ev) {
            var _a, _b, _c, _d;
            // If the mouse button was released without a mouseup firing (e.g. a manipulative
            // swallowed it), reset drag state here to prevent panning from getting stuck.
            if (!('touches' in ev) && ev.buttons === 0 && isDragging.current) {
                isDragging.current = false;
                setIsDraggingState(false);
                return;
            }
            // Only prevent default during actual drag operations, not when touching interactive elements
            // Check if we're in a drag state before preventing default
            if ('touches' in ev &&
                (isDragging.current || dragStartedRef.current || selectionDimRef.current)) {
                ev.preventDefault();
            }
            var clientX = 'clientX' in ev ? ev.clientX : ev.touches[0].clientX;
            var clientY = 'clientY' in ev ? ev.clientY : ev.touches[0].clientY;
            if (panningEnableRef.current) {
                if (!isDragging.current || !scrollRef.current)
                    return;
                // Prevent Safari/iPad blue selection highlight during panning drag
                if ('touches' in ev)
                    ev.preventDefault();
                var dx = clientX - last.current.x;
                var dy = clientY - last.current.y;
                last.current = { x: clientX, y: clientY };
                // User is repositioning — stop auto-recentering on layout changes.
                autoCenterRef.current = false;
                // Correct: Add deltas to existing scroll positions
                scrollRef.current.scrollLeft -= dx;
                scrollRef.current.scrollTop -= dy;
            }
            else if (dragStartedRef.current && mainBoardRef.current) {
                // Prevent Safari/iPad blue selection highlight during drawing drag
                if ('touches' in ev)
                    ev.preventDefault();
                // Skip drawing points when over game materials or shades,
                // but keep dragStarted true so drawing resumes after crossing them.
                var target = ev.target;
                var isOverGameMaterial = target.closest('.diceWrapper, .spinnerManipulativeWrapper, .cardPoolWrapper, .cardWrapperPerspective, .cardWrapper, .shadeContainer, .shades, .counter');
                if (isOverGameMaterial) {
                    return;
                }
                // Use cached rect (avoid layout thrashing)
                var rect = cachedRectRef.current;
                if (!rect)
                    return;
                var _e = cachedScaleRef.current, scaleX = _e.scaleX, scaleY = _e.scaleY;
                var x = (clientX - rect.left) * scaleX;
                var y = (clientY - rect.top) * scaleY;
                // Get the last point before adding new one
                var prevPoint = livePointsRef.current[livePointsRef.current.length - 1];
                // Store point in logical coordinates (for data storage)
                livePointsRef.current.push([x, y]);
                // Draw incrementally on physical canvas (scaled)
                var ctx = (_a = drawCanvasRef.current) === null || _a === void 0 ? void 0 : _a.getLiveContext();
                var physicalScale = ((_b = drawCanvasRef.current) === null || _b === void 0 ? void 0 : _b.getScale()) || 1;
                var stroke = liveStrokeRef.current;
                if (ctx && stroke && prevPoint) {
                    var isHighlighter = stroke.style === leftSideTools.highlighter;
                    var isEraser = stroke.style === leftSideTools.eraser;
                    if (isEraser) {
                        // Draw eraser directly on main canvas so it erases in real-time
                        var mainCtx = (_c = drawCanvasRef.current) === null || _c === void 0 ? void 0 : _c.getMainContext();
                        if (mainCtx) {
                            mainCtx.save();
                            mainCtx.globalCompositeOperation = 'destination-out';
                            mainCtx.strokeStyle = '#FFFFFF';
                            mainCtx.lineWidth = stroke.thickness * physicalScale;
                            mainCtx.lineCap = 'round';
                            mainCtx.lineJoin = 'round';
                            mainCtx.globalAlpha = 1;
                            mainCtx.beginPath();
                            mainCtx.moveTo(prevPoint[0] * physicalScale, prevPoint[1] * physicalScale);
                            mainCtx.lineTo(x * physicalScale, y * physicalScale);
                            mainCtx.stroke();
                            mainCtx.restore();
                        }
                    }
                    else if (isHighlighter) {
                        // Redraw the full stroke each frame to avoid overlapping round-cap circles at alpha 0.3
                        (_d = drawCanvasRef.current) === null || _d === void 0 ? void 0 : _d.clearLiveCanvas();
                        var pts = livePointsRef.current;
                        if (pts.length > 0) {
                            ctx.lineWidth = stroke.thickness * physicalScale;
                            ctx.lineCap = 'round';
                            ctx.lineJoin = 'round';
                            ctx.globalCompositeOperation = 'source-over';
                            ctx.strokeStyle = stroke.color;
                            ctx.globalAlpha = 0.3;
                            ctx.beginPath();
                            ctx.moveTo(pts[0][0] * physicalScale, pts[0][1] * physicalScale);
                            for (var i = 1; i < pts.length; i++) {
                                ctx.lineTo(pts[i][0] * physicalScale, pts[i][1] * physicalScale);
                            }
                            ctx.stroke();
                        }
                    }
                    else {
                        // Pen: draw segment incrementally in physical coordinates
                        ctx.strokeStyle = stroke.color;
                        ctx.lineWidth = stroke.thickness * physicalScale;
                        ctx.lineCap = 'round';
                        ctx.lineJoin = 'round';
                        ctx.globalCompositeOperation = 'source-over';
                        ctx.globalAlpha = 1;
                        ctx.beginPath();
                        ctx.moveTo(prevPoint[0] * physicalScale, prevPoint[1] * physicalScale);
                        ctx.lineTo(x * physicalScale, y * physicalScale);
                        ctx.stroke();
                    }
                }
            }
            else if (selectionDimRef.current !== null && mainBoardRef.current) {
                // Update lasso selection: accumulate path points (downsample to ≥3px apart)
                var _f = getXYScaled(ev), x_1 = _f.x, y_1 = _f.y;
                setSelectionDim(function (prevDim) {
                    if (prevDim === null)
                        return null;
                    var pts = prevDim.points || [{ x: prevDim.x1, y: prevDim.y1 }];
                    var last = pts[pts.length - 1];
                    var dx = x_1 - last.x;
                    var dy = y_1 - last.y;
                    var newPoints = dx * dx + dy * dy >= 9 ? __spreadArray(__spreadArray([], pts, true), [{ x: x_1, y: y_1 }], false) : pts;
                    return __assign(__assign({}, prevDim), { x2: x_1, y2: y_1, points: newPoints });
                });
            }
        };
        var mouseUp = function () {
            var _a;
            isDragging.current = false;
            setIsDraggingState(false);
            // Cancel any pending animation frame
            if (rafIdRef.current) {
                cancelAnimationFrame(rafIdRef.current);
                rafIdRef.current = null;
            }
            // Commit live stroke to drawCommands if it has points
            if (liveStrokeRef.current && livePointsRef.current.length > 0) {
                var completedStroke_1 = __assign(__assign({}, liveStrokeRef.current), { points: livePointsRef.current });
                setDrawCommands(function (prevCommands) { return __spreadArray(__spreadArray([], prevCommands, true), [completedStroke_1], false); });
            }
            // Clear live drawing state
            livePointsRef.current = [];
            lastPointRef.current = null;
            liveStrokeRef.current = null;
            cachedRectRef.current = null;
            (_a = drawCanvasRef.current) === null || _a === void 0 ? void 0 : _a.clearLiveCanvas();
            setDragStarted(false);
            // Capture final lasso state before clearing so selection runs on mouseUp only
            if (selectionDimRef.current && selectionDimRef.current.x2 !== null) {
                setCompletedSelection(__assign({}, selectionDimRef.current));
            }
            setSelectionDim(null);
        };
        (_a = whiteboardRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('mousedown', mouseDown);
        (_b = whiteboardRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('touchstart', mouseDown, { passive: false });
        window.addEventListener('mousemove', mouseMove);
        window.addEventListener('touchmove', mouseMove, { passive: false });
        window.addEventListener('mouseup', mouseUp);
        window.addEventListener('touchend', mouseUp);
        return function () {
            var _a, _b;
            window.removeEventListener('mousemove', mouseMove);
            window.removeEventListener('touchmove', mouseMove);
            window.removeEventListener('mouseup', mouseUp);
            window.removeEventListener('touchend', mouseUp);
            (_a = whiteboardRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('mousedown', mouseDown);
            (_b = whiteboardRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('touchstart', mouseDown);
        };
    }, [
        whiteboardRef,
        mainBoardRef,
        canvasWidth,
        canvasHeight,
        setDrawCommands,
        setSelectionDim,
        setIsDraggingState,
        setDragStarted,
    ]);
    // Keyboard panning: arrow keys scroll the canvas when panning is enabled
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        if (!panningEnable)
            return;
        var PAN_STEP = 50;
        var PAN_STEP_LARGE = 150;
        var handlePanKeyDown = function (e) {
            if (!panningEnableRef.current || !scrollRef.current)
                return;
            var step = e.shiftKey ? PAN_STEP_LARGE : PAN_STEP;
            var directionMap = {
                ArrowLeft: { dx: step, dy: 0, label: t('text.scrolledLeft') },
                ArrowRight: { dx: -step, dy: 0, label: t('text.scrolledRight') },
                ArrowUp: { dx: 0, dy: step, label: t('text.scrolledUp') },
                ArrowDown: { dx: 0, dy: -step, label: t('text.scrolledDown') },
            };
            var dir = directionMap[e.key];
            if (!dir) {
                // Escape exits panning mode
                if (e.key === 'Escape') {
                    e.preventDefault();
                    setPanningEnable(false);
                    announce(t('text.panningDisabled'));
                    // Return focus to panning button
                    var panBtn = document.querySelector('.panningBtn');
                    if (panBtn)
                        panBtn.focus();
                }
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            // User is repositioning — stop auto-recentering on layout changes.
            autoCenterRef.current = false;
            scrollRef.current.scrollLeft -= dir.dx;
            scrollRef.current.scrollTop -= dir.dy;
            announce(dir.label);
        };
        var handlePanMenuOpen = function (e) {
            var _a;
            if (!panningEnableRef.current)
                return;
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                // Open the canvas pan context menu at the center of the viewport
                var scrollEl = (_a = document.getElementById('wrapperDiv')) === null || _a === void 0 ? void 0 : _a.parentElement;
                var rect = scrollEl === null || scrollEl === void 0 ? void 0 : scrollEl.getBoundingClientRect();
                var cx = rect ? rect.left + rect.width / 2 : window.innerWidth / 2;
                var cy = rect ? rect.top + rect.height / 2 : window.innerHeight / 2;
                setContextMenu({ x: cx, y: cy, manipulativeId: 'canvas_pan' });
            }
        };
        // Auto-open the pan menu when panning is activated via keyboard (panning
        // button had focus). Mouse users click the button then drag — don't
        // interrupt them with an unexpected menu.
        var activatedByKeyboard = ((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.classList.contains('panningBtn')) ||
            ((_b = document.activeElement) === null || _b === void 0 ? void 0 : _b.closest('.panningBtn')) !== null;
        // Focus whiteboard when panning is enabled
        (_c = whiteboardRef.current) === null || _c === void 0 ? void 0 : _c.focus();
        announce(t('text.panningEnabled'));
        if (activatedByKeyboard) {
            var scrollEl = (_d = document.getElementById('wrapperDiv')) === null || _d === void 0 ? void 0 : _d.parentElement;
            var rect = scrollEl === null || scrollEl === void 0 ? void 0 : scrollEl.getBoundingClientRect();
            var cx = rect ? rect.left + rect.width / 2 : window.innerWidth / 2;
            var cy = rect ? rect.top + rect.height / 2 : window.innerHeight / 2;
            setContextMenu({ x: cx, y: cy, manipulativeId: 'canvas_pan' });
        }
        (_e = whiteboardRef.current) === null || _e === void 0 ? void 0 : _e.addEventListener('keydown', handlePanKeyDown);
        (_f = whiteboardRef.current) === null || _f === void 0 ? void 0 : _f.addEventListener('keydown', handlePanMenuOpen);
        return function () {
            var _a, _b;
            (_a = whiteboardRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('keydown', handlePanKeyDown);
            (_b = whiteboardRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('keydown', handlePanMenuOpen);
        };
    }, [panningEnable, setPanningEnable, setContextMenu, t]);
    // Memoize getTools to avoid recreation on every render
    var getTools = useCallback(function (selectedToolObj, allToolsObj) {
        var _a;
        if (selectedToolObj.length === 1) {
            var _toolName = selectedToolObj[0].split('_')[0];
            var _pos = Number(selectedToolObj[0].split('_')[1]);
            if (_toolName === 'annotations') {
                return allToolsObj[(_a = annotations[_pos]) === null || _a === void 0 ? void 0 : _a.type];
            }
            if (_toolName === 'manipulativeGroup') {
                // manipulativeMerged.find((_item) => _item.type === 'group' && (_item as manipulativeGroupInter).groupId === _toolName);
                //  return allToolsObj[manipulative[_pos].type];
            }
            return allToolsObj[_toolName];
        }
        // const arrays = selectedToolObj.map(key => {
        //   const _toolName = key.split('_')[0];
        //   const _pos = Number(key.split('_')[1]);
        //   if (_toolName === 'annotations') {
        //     return allToolsObj[annotations[_pos]?.type];
        //   }
        //   return allToolsObj[key.split('_')[0]];
        // });
        // // console.log(arrays, selectedToolObj, 'arrays');
        // if (arrays.length === 0) return [];
        // return arrays.reduce((acc, curr) => {
        //   if (!curr || curr.length === 0) return acc;
        //   const currIds = curr.map((item: any) =>
        //     typeof item === 'string' ? btnConfig[item]?.id : item.id
        //   );
        //   return acc.filter((item: any) => {
        //     const itemId = typeof item === 'string' ? btnConfig[item]?.id : item.id;
        //     return currIds.includes(itemId);
        //   });
        // }, arrays[0] ?? []);
        return [];
    }, [annotations, btnConfig]);
    useEffect(function () {
        if (completedSelection === null ||
            completedSelection.x2 === null ||
            completedSelection.y2 === null) {
            return;
        }
        var _sel = [];
        var lassoPoints = completedSelection.points;
        var useLasso = lassoPoints && lassoPoints.length > 2;
        // Bounding-box fallback (used for rect-overlap tests on wide items)
        var _a = getMinMax({ x: completedSelection.x1, y: completedSelection.y1 }, { x: completedSelection.x2, y: completedSelection.y2 }), minX = _a.minX, minY = _a.minY, maxX = _a.maxX, maxY = _a.maxY;
        var x = minX;
        var y = minY;
        var w = maxX - x;
        var h = maxY - y;
        // Point-in-lasso when enough points; otherwise fall back to bounding rect
        var checkInsideRect = useLasso
            ? function (xPt, yPt) {
                if (xPt === void 0) { xPt = 0; }
                if (yPt === void 0) { yPt = 0; }
                return isPointInPolygon(xPt, yPt, lassoPoints);
            }
            : function (xPt, yPt) {
                if (xPt === void 0) { xPt = 0; }
                if (yPt === void 0) { yPt = 0; }
                return x < xPt && x + w > xPt && y < yPt && y + h > yPt;
            };
        var checkRectOverlap = useLasso
            ? function (r2X, r2Y, r2W, r2H) {
                if (r2X === void 0) { r2X = 0; }
                if (r2Y === void 0) { r2Y = 0; }
                if (r2W === void 0) { r2W = 0; }
                if (r2H === void 0) { r2H = 0; }
                // Check if any corner of the item falls inside the lasso
                return (isPointInPolygon(r2X, r2Y, lassoPoints) ||
                    isPointInPolygon(r2X + r2W, r2Y, lassoPoints) ||
                    isPointInPolygon(r2X, r2Y + r2H, lassoPoints) ||
                    isPointInPolygon(r2X + r2W, r2Y + r2H, lassoPoints));
            }
            : function (r2X, r2Y, r2W, r2H) {
                if (r2X === void 0) { r2X = 0; }
                if (r2Y === void 0) { r2Y = 0; }
                if (r2W === void 0) { r2W = 0; }
                if (r2H === void 0) { r2H = 0; }
                return x < r2X + r2W && x + w > r2X && y < r2Y + r2H && y + h > r2Y;
            };
        // Use refs to read current data without adding them as dependencies
        // This breaks the cascade: manipulative/annotations/text changes no longer re-trigger this effect
        var currentAnnotations = annotationsRef.current;
        var currentText = textRef.current;
        var currentManipulative = manipulativeRef.current;
        // Process annotations
        currentAnnotations.forEach(function (_ann, _ind) {
            var _a, _b;
            if (_ann.type === 'line') {
                if (((_a = _ann.data.points) === null || _a === void 0 ? void 0 : _a[0]) &&
                    ((_b = _ann.data.points) === null || _b === void 0 ? void 0 : _b[1]) &&
                    checkInsideRect(_ann.data.points[0].x, _ann.data.points[0].y) &&
                    checkInsideRect(_ann.data.points[1].x, _ann.data.points[1].y)) {
                    _sel.push("annotations_".concat(_ind));
                }
            }
            else {
                if (_ann.data.center && checkInsideRect(_ann.data.center.x, _ann.data.center.y)) {
                    _sel.push("annotations_".concat(_ind));
                }
            }
        });
        // Process text
        currentText.forEach(function (_ann, _ind) {
            if (_ann.data.position && checkInsideRect(_ann.data.position.x, _ann.data.position.y)) {
                _sel.push("text_".concat(_ind));
            }
        });
        // Process tables
        var currentTable = tableRef.current;
        currentTable.forEach(function (_tbl, _ind) {
            if (_tbl.data.position) {
                var tX = toNumber(_tbl.data.position.x);
                var tY = toNumber(_tbl.data.position.y);
                var tW = _tbl.data.colWidth.reduce(function (sum, w) { return sum + toNumber(w); }, 0);
                var tH = _tbl.data.rowsHeight.reduce(function (sum, h) { return sum + toNumber(h); }, 0);
                if (checkRectOverlap(tX, tY, tW, tH)) {
                    _sel.push("tableText_".concat(_ind));
                }
            }
        });
        // Process shades — previously omitted entirely, so a shade caught inside a
        // rubber-band/lasso selection never joined `selectedTool` and could never
        // register as a multi-select follower (Shades.tsx's follower effect gates
        // on `selectedTool.includes(localObj.selectionType)`, which was always
        // false for shades since they never appeared in this selection at all).
        var currentShades = shadesRef.current;
        currentShades.forEach(function (_shd, _ind) {
            if (_shd.data.position) {
                var sX = _shd.data.position.x;
                var sY = _shd.data.position.y;
                var sW = _shd.data.dimensions.width;
                var sH = _shd.data.dimensions.height;
                if (checkRectOverlap(sX, sY, sW, sH)) {
                    _sel.push("shades_".concat(_shd.id, "_").concat(_ind));
                }
            }
        });
        // Process manipulative
        currentManipulative.forEach(function (_man) {
            var _a, _b, _c, _d, _e, _f, _g;
            if (!_man || !_man.data)
                return;
            if (_man.data.type === 'dice') {
                // Dice stores `center` as its top-left corner (it's rendered with
                // `top: center.y; left: center.x`). The marquee should hit-test
                // against the dice's *visual* center so users can select with a
                // partial-overlap lasso, matching how spinner / counter / etc.
                // already work. Adjust by (dimensions × scale) / 2 to find center.
                var dDim = (_a = _man.data.dimensions) !== null && _a !== void 0 ? _a : { width: 96, height: 89 };
                var dScale = (_b = _man.data.scale) !== null && _b !== void 0 ? _b : 1;
                var diceCx = _man.data.center.x + (dDim.width * dScale) / 2;
                var diceCy = _man.data.center.y + (dDim.height * dScale) / 2;
                if (_man.data.groupId === undefined && checkInsideRect(diceCx, diceCy)) {
                    _sel.push(_man.data.id);
                }
                else if (_man.data.groupId !== undefined && checkInsideRect(diceCx, diceCy)) {
                    if (!_sel.includes(_man.data.groupId)) {
                        _sel.push(_man.data.groupId);
                    }
                }
            }
            if (_man.data.type === 'protractor') {
                var pData = _man.data;
                if (checkInsideRect(pData.center.x, pData.center.y)) {
                    _sel.push(pData.id);
                }
            }
            if (_man.data.type === 'deck') {
                if (checkInsideRect(_man.data.center.x, _man.data.center.y)) {
                    _sel.push(_man.data.id);
                }
                _man.data.cards.forEach(function (_card) {
                    if (checkInsideRect(_card.position.x, _card.position.y)) {
                        _sel.push(_card.id);
                    }
                });
            }
            if (_man.data.type === 'spinner') {
                if (checkInsideRect(_man.data.center.x, _man.data.center.y)) {
                    _sel.push((_c = _man.data.id) !== null && _c !== void 0 ? _c : '');
                }
            }
            if (_man.data.type === 'numberCharts') {
                if (checkInsideRect(_man.data.center.x, _man.data.center.y)) {
                    _sel.push((_d = _man.data.id) !== null && _d !== void 0 ? _d : '');
                }
            }
            if (_man.data.type === 'linkingCubes') {
                if (checkInsideRect(_man.data.center.x, _man.data.center.y)) {
                    _sel.push((_e = _man.data.id) !== null && _e !== void 0 ? _e : '');
                }
            }
            if (_man.data.type === 'arrayModels') {
                if (checkInsideRect(_man.data.center.x, _man.data.center.y)) {
                    _sel.push(_man.data.id);
                }
            }
            if (_man.data.type === 'coloredTiles') {
                if (_man.data.groupId === undefined) {
                    if (checkInsideRect(_man.data.center.x, _man.data.center.y)) {
                        _sel.push(_man.data.id);
                    }
                }
                else {
                    if (checkInsideRect(_man.data.center.x, _man.data.center.y) &&
                        !_sel.includes(_man.data.groupId)) {
                        _sel.push(_man.data.groupId);
                    }
                }
            }
            if (_man.data.type === 'linearPiece') {
                if (checkInsideRect(_man.data.center.x, _man.data.center.y)) {
                    if (_man.data.groupId) {
                        if (!_sel.includes(_man.data.groupId))
                            _sel.push(_man.data.groupId);
                    }
                    else {
                        _sel.push(_man.data.id);
                    }
                }
            }
            if (_man.data.type === 'patternShapes') {
                // Skip outline shapes — they should not be selectable
                if (_man.data.isStaticOutline || _man.data.isOutline)
                    return;
                var psData = _man.data;
                var psBounds = SHAPE_BOUNDS[psData.shapeType];
                var psCx = psData.center.x + (psBounds ? psBounds.w / 2 : 0);
                var psCy = psData.center.y + (psBounds ? psBounds.h / 2 : 0);
                if (checkInsideRect(psCx, psCy)) {
                    // If the pattern shape belongs to a group, prefer selecting the
                    // group token; otherwise select the individual shape
                    if (_man.data.groupId) {
                        if (!_sel.includes(_man.data.groupId))
                            _sel.push(_man.data.groupId);
                    }
                    else {
                        _sel.push(_man.data.id);
                    }
                }
            }
            if (_man.data.type === 'coinsAndCounters') {
                // Mirror Pattern Shapes: hit-test the visual center of the counter.
                // If it's part of a formal group, prefer selecting the groupId token;
                // otherwise select the individual counter id.
                var ccCx = _man.data.center.x;
                var ccCy = _man.data.center.y;
                if (checkInsideRect(ccCx, ccCy)) {
                    if (_man.data.groupId) {
                        if (!_sel.includes(_man.data.groupId))
                            _sel.push(_man.data.groupId);
                    }
                    else {
                        _sel.push(_man.data.id);
                    }
                }
            }
            if (_man.data.type === 'analog') {
                if (checkInsideRect(_man.data.center.x, _man.data.center.y)) {
                    _sel.push(_man.data.id);
                }
            }
            if (_man.data.type === 'timer') {
                if (checkInsideRect(_man.data.center.x, _man.data.center.y)) {
                    _sel.push(_man.data.id);
                }
            }
            // NumberFrames are not lasso-selectable; select them directly by clicking instead
            if (_man.data.type === 'numberRacks') {
                if (checkInsideRect(_man.data.center.x, _man.data.center.y)) {
                    _sel.push(_man.data.id);
                }
            }
            if (_man.data.type === 'counter') {
                var cData = _man.data;
                if (cData.customImage && checkInsideRect(cData.center.x, cData.center.y)) {
                    _sel.push(cData.id);
                }
            }
            if (_man.data.type === 'numberFrameCounter') {
                var counter_1 = _man.data;
                // For framed counters, derive the actual visual position from calculateTokenPosition
                // (same logic as Counter.tsx actualPosition useMemo) so lasso selection matches what's visible.
                var checkX = counter_1.center.x;
                var checkY = counter_1.center.y;
                if (counter_1.frameId && !((_f = counter_1.lock) === null || _f === void 0 ? void 0 : _f.positioning)) {
                    var frameItem = manipulativeRef.current.find(function (m) { return m.data.type === 'numberFrames' && m.data.id === counter_1.frameId; });
                    if (frameItem) {
                        var frame = frameItem.data;
                        if (frame.tokens) {
                            for (var _i = 0, _h = Object.entries(frame.tokens); _i < _h.length; _i++) {
                                var _j = _h[_i], cellIndexStr = _j[0], tokenId = _j[1];
                                if (tokenId === counter_1.id) {
                                    var pos = calculateTokenPosition(frame, parseInt(cellIndexStr));
                                    checkX = pos.x;
                                    checkY = pos.y;
                                    break;
                                }
                            }
                        }
                    }
                }
                if (checkInsideRect(checkX, checkY)) {
                    _sel.push(counter_1.id);
                }
            }
            if (_man.data.type === 'fractionTiles') {
                var pData = _man.data;
                var hit = false;
                if (pData.shapeType === 'rectangle') {
                    hit = checkRectOverlap(pData.center.x, pData.center.y, pData.dimensions.width, pData.dimensions.height);
                }
                else {
                    // Circle fraction tile — use representative interior points rather than
                    // bounding-box corners to avoid selecting nearby tiles whose bounding
                    // rectangles overlap the lasso but whose visible sector does not.
                    var bb = getCircleBoundingBox(pData.fractionSize, (_g = pData.rotation) !== null && _g !== void 0 ? _g : 0, pData.scale, pData.customSweep);
                    var s = pData.scale;
                    // Bounding-box centre in whiteboard coordinates — a unique point per
                    // sector. Lasso must pass through the visible centroid of the arc shape.
                    var bbCx = pData.center.x + (bb.x + bb.width / 2) * s;
                    var bbCy = pData.center.y + (bb.y + bb.height / 2) * s;
                    hit = checkInsideRect(bbCx, bbCy);
                }
                if (hit) {
                    // Consolidate to the group id (same convention as NMP/coloredTiles/
                    // patternShapes below) so a lasso over an already-grouped set is
                    // recognized as that group rather than N standalone tiles — otherwise
                    // the Group/Ungroup button logic (which keys off selectedTool being
                    // exactly [groupId]) shows "Group" instead of "Ungroup".
                    if (pData.groupId) {
                        if (!_sel.includes(pData.groupId))
                            _sel.push(pData.groupId);
                    }
                    else {
                        _sel.push(pData.id);
                    }
                }
            }
            if (_man.data.type === 'numberPiece' || _man.data.type === 'moneyPiece') {
                var pData = _man.data;
                if (_man.data.groupId === undefined) {
                    if (!_sel.includes(pData.id) && checkInsideRect(pData.center.x, pData.center.y)) {
                        _sel.push(pData.id);
                    }
                }
                else {
                    if (checkInsideRect(pData.center.x, pData.center.y) &&
                        !_sel.includes(_man.data.groupId)) {
                        _sel.push(_man.data.groupId);
                    }
                }
            }
            if (_man.data.type === 'numberLine') {
                var nlData = _man.data;
                if (checkInsideRect(nlData.center.x, nlData.center.y)) {
                    _sel.push(nlData.id);
                }
            }
            if (_man.data.type === 'jumpBar') {
                var jbData = _man.data;
                if (checkRectOverlap(jbData.center.x, jbData.center.y, jbData.width, 76)) {
                    _sel.push(jbData.id);
                }
            }
            if (_man.data.type === 'customTick') {
                var ctData = _man.data;
                if (checkInsideRect(ctData.center.x, ctData.center.y)) {
                    _sel.push(ctData.id);
                }
            }
        });
        // Keep every lasso-captured item regardless of type, so a marquee/lasso can
        // multi-select mixed manipulatives (e.g. a dice + a counter) and drag them
        // together. (Previously a TEMP filter collapsed the selection to a single
        // type here, which made cross-type multi-select appear broken.)
        var _selUnique = new Set(_sel);
        if (_selUnique.size !== _sel.length) {
            var counts_1 = new Map();
            _sel.forEach(function (id) { var _a; return counts_1.set(id, ((_a = counts_1.get(id)) !== null && _a !== void 0 ? _a : 0) + 1); });
            var duplicatedIds = Array.from(counts_1.entries()).filter(function (_a) {
                var c = _a[1];
                return c > 1;
            });
            console.log('[MultiDrag] rubber-band selection built', JSON.stringify({
                rawLength: _sel.length,
                uniqueLength: _selUnique.size,
                duplicatedIds: duplicatedIds,
            }));
        }
        // Only update selectedTool if the selection actually changed
        // This prevents cascading re-renders when clicking blank area repeatedly
        var currentSelected = selectedToolRef.current;
        var selectionChanged = _sel.length !== currentSelected.length || _sel.some(function (id, i) { return id !== currentSelected[i]; });
        if (selectionChanged) {
            setSelectedTool(_sel);
        }
        setCompletedSelection(null);
    }, [completedSelection, setSelectedTool]);
    // Handle selection completion - when selection dim is set and completed
    useEffect(function () {
        if (selectionDim && selectionDim.x2 !== null && selectionDim.y2 !== null) {
            // Selection rectangle was drawn, items should be selected via the other effect
            // Don't need to do anything here - the selectionDim effect handles it
        }
    }, [selectionDim]);
    // Memoize toolBtn calculation
    var toolBtnMemoized = useMemo(function () {
        // console.log(selectedTool, btnConfigJSON, 'selectedTool in whiteboard memoized');
        if (!btnConfigJSON || selectedTool.length === 0)
            return [];
        return getTools(selectedTool, btnConfigJSON) || [];
    }, [selectedTool, btnConfigJSON, getTools]);
    useEffect(function () {
        setToolBtn(toolBtnMemoized);
    }, [toolBtnMemoized]);
    useEffect(function () {
        var handleHeaderClicked = function (data) {
            switch (data.id) {
                case 'downloadSS':
                    downloadMainHolderScreenshot();
                    break;
                case 'copySS':
                    copyMainHolderScreenshotToClipboard();
                    break;
            }
        };
        customEventHandler.addEventListener('headerClicked', handleHeaderClicked);
        return function () {
            customEventHandler.removeEventListener('headerClicked', handleHeaderClicked);
        };
    }, []);
    // Track math keyboard visibility for mathtext button active state
    useEffect(function () {
        var handler = function (payload) {
            setMathKeyboardVisible(payload.visible);
        };
        customEventHandler.addEventListener('mathKeyboardToggle', handler);
        return function () { return customEventHandler.removeEventListener('mathKeyboardToggle', handler); };
    }, []);
    var mathTextCollapsibleState = useMemo(function () {
        var _a;
        // Determine active thickness from selected table
        var activeThicknessIdx = null;
        var tableEntry = selectedTool.find(function (t) { return t.startsWith('tableText_'); });
        if (tableEntry) {
            var tblIdx = Number(tableEntry.split('_')[1]);
            var tbl = table[tblIdx];
            if (tbl) {
                var bw = tbl.data.borderWidth || 2;
                var bwToIndex = { 2: 0, 3: 1, 5: 2, 6: 3 };
                activeThicknessIdx = (_a = bwToIndex[bw]) !== null && _a !== void 0 ? _a : 0;
            }
        }
        return [
            {
                id: 'mathtext',
                activeElements: null,
                activeCollapsible: false,
                isActive: mathKeyboardVisible,
            },
            {
                id: 'tableThickness',
                activeElements: activeThicknessIdx,
                activeCollapsible: false,
                isActive: false,
            },
        ];
    }, [mathKeyboardVisible, selectedTool, table]);
    // Memoize getBottomPannelPosition to avoid recalculation on every render
    var getBottomPannelPosition = useCallback(function () {
        var x1 = Infinity, y1 = Infinity, x2 = 0, y2 = 0, rotation = 0, padding = 10;
        selectedTool.forEach(function (_toolData) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22;
            if (_toolData.includes('manipulativeGroup')) {
                var groupItems = manipulative.filter(function (m) { return m && m.data && m.data.groupId === _toolData; });
                if (groupItems.length === 0)
                    return;
                var _pad_1 = 20;
                var _newX = Number(((_a = groupItems[0].data.groupCenter) === null || _a === void 0 ? void 0 : _a.x) || 0);
                var _newY = Number(((_b = groupItems[0].data.groupCenter) === null || _b === void 0 ? void 0 : _b.y) || 0);
                var width_1 = 0;
                var height_1 = 0;
                groupItems.forEach(function (item, index) {
                    // const posX = Number(item.data.center?.x || 0);
                    // const posY = Number(item.data.center?.y || 0);
                    var _a, _b, _c, _d, _e, _f;
                    var beforeGroupScale = (_a = item.data.beforeGroupScale) !== null && _a !== void 0 ? _a : 1;
                    var groupScale = (_b = item.data.groupScale) !== null && _b !== void 0 ? _b : 1;
                    width_1 += _pad_1 + ((_d = (_c = item.data.defaultDimensions) === null || _c === void 0 ? void 0 : _c.width) !== null && _d !== void 0 ? _d : 1) * beforeGroupScale * groupScale;
                    height_1 = Math.max(height_1, _pad_1 + ((_f = (_e = item.data.defaultDimensions) === null || _e === void 0 ? void 0 : _e.height) !== null && _f !== void 0 ? _f : 1) * beforeGroupScale * groupScale);
                });
                x1 = Math.min(x1, _newX);
                y1 = Math.min(y1, _newY);
                x2 = Math.max(x2, _newX + width_1 + _pad_1);
                y2 = Math.max(y2, _newY + height_1 + _pad_1);
            }
            if (_toolData.includes('annotations')) {
                var _ann = annotations[Number(_toolData.split('_')[1])];
                if (!_ann || !_ann.data)
                    return;
                var _newX = void 0, _newY = void 0, width = void 0, height = void 0;
                if (_ann.type !== 'line') {
                    _newX =
                        toNumber((_c = _ann.data.center) === null || _c === void 0 ? void 0 : _c.x) -
                            toNumber((_d = _ann.data.dimensions) === null || _d === void 0 ? void 0 : _d.width) / 2 -
                            toNumber(_ann.data.thickness) / 2;
                    _newY =
                        toNumber((_e = _ann.data.center) === null || _e === void 0 ? void 0 : _e.y) -
                            toNumber((_f = _ann.data.dimensions) === null || _f === void 0 ? void 0 : _f.height) / 2 -
                            toNumber(_ann.data.thickness) / 2;
                    width = toNumber((_g = _ann.data.dimensions) === null || _g === void 0 ? void 0 : _g.width) + toNumber(_ann.data.thickness);
                    height = toNumber((_h = _ann.data.dimensions) === null || _h === void 0 ? void 0 : _h.height) + toNumber(_ann.data.thickness);
                    if (selectedTool.length == 1) {
                        rotation = _ann.data.rotation || 0;
                    }
                }
                else {
                    var _23 = getMinMax((_j = _ann.data.points) === null || _j === void 0 ? void 0 : _j[0], (_k = _ann.data.points) === null || _k === void 0 ? void 0 : _k[1]), minX_1 = _23.minX, minY_1 = _23.minY, maxX_1 = _23.maxX, maxY_1 = _23.maxY;
                    _newX = minX_1 - _ann.data.thickness / 2;
                    _newY = minY_1 - _ann.data.thickness / 2;
                    width = maxX_1 - minX_1;
                    height = maxY_1 - minY_1;
                }
                var _24 = calculateBoxWithPaddingAndRotation(_newX, _newY, width, height, _ann.data.rotation || 0, _ann.type !== 'line' ? padding : 25), minX = _24.minX, minY = _24.minY, maxX = _24.maxX, maxY = _24.maxY;
                x1 = minX;
                y1 = minY;
                x2 = maxX;
                y2 = maxY;
            }
            if (_toolData.includes('shades')) {
                var _splittedId = _toolData.split('_');
                var _shd = shades[Number(_splittedId[_splittedId.length - 1])];
                if (!_shd || !_shd.data)
                    return;
                var _newX = void 0, _newY = void 0, width = void 0, height = void 0;
                _newX = toNumber((_l = _shd.data.position) === null || _l === void 0 ? void 0 : _l.x);
                _newY = toNumber((_m = _shd.data.position) === null || _m === void 0 ? void 0 : _m.y);
                width = toNumber(_shd.data.dimensions.width);
                height = toNumber(_shd.data.dimensions.height);
                x1 = Math.min(x1, _newX);
                y1 = Math.min(y1, _newY);
                x2 = Math.max(x2, _newX + width);
                y2 = Math.max(y2, _newY + height);
            }
            if (_toolData.includes('text')) {
                var _ann = text[Number(_toolData.split('_')[1])];
                if (!_ann || !_ann.data)
                    return;
                var _newX = void 0, _newY = void 0, width = void 0, height = void 0;
                var posX = toNumber((_o = _ann.data.position) === null || _o === void 0 ? void 0 : _o.x);
                var posY = toNumber((_p = _ann.data.position) === null || _p === void 0 ? void 0 : _p.y);
                width = toNumber(_ann.data.lineWidth || 0);
                height = toNumber(_ann.data.height || 0);
                // bounding box top-left
                _newX = posX;
                _newY = posY;
                if (selectedTool.length === 1) {
                    rotation = _ann.data.rotation || 0;
                }
                // x1 = Math.min(x1, _newX - width / 2 - padding);
                // y1 = Math.min(y1, _newY - height / 2 - padding);
                // x2 = Math.max(x2, _newX + width / 2 + padding);
                // y2 = Math.max(y2, _newY + height / 2 + padding);
                // x1 = Math.min(x1, _newX - padding);
                // y1 = Math.min(y1, _newY - padding);
                // x2 = Math.max(x2, _newX + width + padding);
                // y2 = Math.max(y2, _newY + height + padding);
                var _25 = calculateBoxWithPaddingAndRotation(_newX, _newY, width, height, _ann.data.rotation || 0, padding, true), minX = _25.minX, minY = _25.minY, maxX = _25.maxX, maxY = _25.maxY;
                x1 = minX;
                y1 = minY;
                x2 = maxX;
                y2 = maxY;
            }
            if (_toolData.includes('tableText')) {
                var _splittedId = _toolData.split('_');
                var _index = _splittedId.length >= 4 ? +_splittedId[_splittedId.length - 3] : +_splittedId[1];
                var _selectedTable = table[_index];
                if (!_selectedTable || !_selectedTable.data)
                    return;
                var _newX = toNumber(_selectedTable.data.position.x);
                var _newY = toNumber(_selectedTable.data.position.y);
                var totalWidth = _selectedTable.data.colWidth.reduce(function (sum, w) { return sum + toNumber(w); }, 0);
                var totalHeight = _selectedTable.data.rowsHeight.reduce(function (sum, h) { return sum + toNumber(h); }, 0);
                // Add extra for cell padding/borders not included in rowsHeight data
                var numRows = _selectedTable.data.rowsHeight.length;
                var renderedHeight = totalHeight + numRows * 8;
                x1 = Math.min(x1, _newX);
                y1 = Math.min(y1, _newY);
                x2 = Math.max(x2, _newX + totalWidth);
                // Add gap to clear resize handles, row/column controls below the table
                y2 = Math.max(y2, _newY + renderedHeight + 15);
            }
            if (_toolData.includes('dice')) {
                var item = manipulative.find(function (m) { return m.data.id === _toolData; });
                if (!item)
                    return; // id not found
                if (item.data.type === 'dice') {
                    var _newX = void 0, _newY = void 0, width = void 0, height = void 0;
                    var posX = Number(((_q = item.data.center) === null || _q === void 0 ? void 0 : _q.x) || 0);
                    var posY = Number(((_r = item.data.center) === null || _r === void 0 ? void 0 : _r.y) || 0);
                    width = Number(((_s = item.data.dimensions) === null || _s === void 0 ? void 0 : _s.width) || 0);
                    height = Number(((_u = item.data.dimensions) === null || _u === void 0 ? void 0 : _u.height) || 0);
                    _newX = posX;
                    _newY = posY;
                    // bounding box update
                    x1 = Math.min(x1, _newX);
                    y1 = Math.min(y1, _newY);
                    x2 = Math.max(x2, _newX + width);
                    y2 = Math.max(y2, _newY + height);
                }
            }
            if (_toolData.includes('protractor')) {
                var item = manipulative.find(function (m) { return m.data.id === _toolData; });
                if (!item)
                    return;
                // Cast the type check to string to avoid the "No Overlap" error
                if (item.data.type === 'protractor') {
                    var pData = item.data; // Cast to any to use pData.center etc.
                    var _pad = 10;
                    // Using the same variable names you had
                    var posX = Number((_v = pData.center) === null || _v === void 0 ? void 0 : _v.x);
                    var posY = Number((_w = pData.center) === null || _w === void 0 ? void 0 : _w.y);
                    var width = Number((_x = pData.dimensions) === null || _x === void 0 ? void 0 : _x.width) * (pData.scale || 1);
                    var height = Number((_y = pData.dimensions) === null || _y === void 0 ? void 0 : _y.height) * (pData.scale || 1);
                    // Calculate bounding box based on your Protractor's specific center logic
                    x1 = Math.min(x1, posX - width / 2);
                    y1 = Math.min(y1, posY - height);
                    x2 = Math.max(x2, posX + width / 2);
                    y2 = Math.max(y2, posY);
                }
            }
            if (_toolData.includes('deck')) {
                var item = manipulative.find(function (m) { return m.data.id === _toolData; });
                if (!item)
                    return; // id not found
                if (item.data.type === 'deck') {
                    var _newX = void 0, _newY = void 0, width = void 0, height = void 0;
                    var posX = Number(((_z = item.data.center) === null || _z === void 0 ? void 0 : _z.x) || 0);
                    var posY = Number(((_0 = item.data.center) === null || _0 === void 0 ? void 0 : _0.y) || 0);
                    width = Number(((_1 = item.data.dimensions) === null || _1 === void 0 ? void 0 : _1.width) * item.data.scale || 0);
                    height = Number(((_2 = item.data.dimensions) === null || _2 === void 0 ? void 0 : _2.height) * item.data.scale || 0);
                    _newX = posX;
                    _newY = posY;
                    // bounding box update
                    x1 = Math.min(x1, _newX);
                    y1 = Math.min(y1, _newY);
                    x2 = Math.max(x2, _newX + width);
                    y2 = Math.max(y2, _newY + height);
                }
            }
            if (_toolData.includes('card')) {
                var result = manipulative
                    .map(function (m) {
                    var _a;
                    return ({
                        manipulative: m,
                        card: m.data.type === 'deck'
                            ? (_a = m.data.cards) === null || _a === void 0 ? void 0 : _a.find(function (card) { return card.id === _toolData; })
                            : undefined,
                    });
                })
                    .find(function (entry) { return entry.card; });
                var deck = result === null || result === void 0 ? void 0 : result.manipulative;
                var card = result === null || result === void 0 ? void 0 : result.card;
                if (card === undefined)
                    return; // id not found
                if ((deck === null || deck === void 0 ? void 0 : deck.data.type) === 'deck') {
                    var _newX = void 0, _newY = void 0, width = void 0, height = void 0;
                    var posX = Number(card.position.x);
                    var posY = Number(card.position.y);
                    width = Number(((_3 = card === null || card === void 0 ? void 0 : card.dimensions) === null || _3 === void 0 ? void 0 : _3.width) * deck.data.scale);
                    height = Number(((_4 = card === null || card === void 0 ? void 0 : card.dimensions) === null || _4 === void 0 ? void 0 : _4.height) * deck.data.scale);
                    _newX = posX;
                    _newY = posY;
                    // bounding box update
                    x1 = Math.min(x1, _newX);
                    y1 = Math.min(y1, _newY);
                    x2 = Math.max(x2, _newX + width);
                    y2 = Math.max(y2, _newY + height);
                }
            }
            if (_toolData.includes('spinner')) {
                var item = manipulative.find(function (m) { return m.data.id === _toolData; });
                if (!item)
                    return; // id not found
                if (item.data.type === 'spinner') {
                    var _newX = void 0, _newY = void 0;
                    var posX = Number(item.data.center.x || 0);
                    var posY = Number(item.data.center.y || 0);
                    var diameter = Number(item.data.radius || 0);
                    _newX = posX;
                    _newY = posY;
                    // bounding box update
                    x1 = Math.min(x1, _newX);
                    y1 = Math.min(y1, _newY);
                    x2 = Math.max(x2, _newX + diameter);
                    y2 = Math.max(y2, _newY + diameter);
                }
            }
            if (_toolData.includes('newMath')) {
                var _ann = text[Number(_toolData.split('_')[1])];
                var _newX = void 0, _newY = void 0, width = void 0, height = void 0;
                var posX = toNumber((_5 = _ann.data.position) === null || _5 === void 0 ? void 0 : _5.x);
                var posY = toNumber((_6 = _ann.data.position) === null || _6 === void 0 ? void 0 : _6.y);
                width = toNumber(_ann.data.lineWidth || 0);
                height = toNumber(_ann.data.height || 0);
                // bounding box top-left
                _newX = posX;
                _newY = posY;
                if (selectedTool.length === 1) {
                    rotation = _ann.data.rotation || 0;
                }
                // x1 = Math.min(x1, _newX - width / 2 - padding);
                // y1 = Math.min(y1, _newY - height / 2 - padding);
                // x2 = Math.max(x2, _newX + width / 2 + padding);
                // y2 = Math.max(y2, _newY + height / 2 + padding);
                // x1 = Math.min(x1, _newX - padding);
                // y1 = Math.min(y1, _newY - padding);
                // x2 = Math.max(x2, _newX + width + padding);
                // y2 = Math.max(y2, _newY + height + padding);
                var _26 = calculateBoxWithPaddingAndRotation(_newX, _newY, width, height, _ann.data.rotation || 0, padding, true), minX = _26.minX, minY = _26.minY, maxX = _26.maxX, maxY = _26.maxY;
                x1 = minX;
                y1 = minY;
                x2 = maxX;
                y2 = maxY;
            }
            if (_toolData.includes('timer')) {
                var item = manipulative.find(function (m) { return m.data.id === _toolData; });
                if (!item)
                    return; // id not found
                if (item.data.type === 'timer') {
                    var _newX = void 0, _newY = void 0, width = void 0, height = void 0;
                    var posX = Number(((_7 = item.data.center) === null || _7 === void 0 ? void 0 : _7.x) || 0);
                    var posY = Number(((_8 = item.data.center) === null || _8 === void 0 ? void 0 : _8.y) || 0);
                    width = Number(((_9 = item.data.dimensions) === null || _9 === void 0 ? void 0 : _9.width) || 0);
                    height = Number(((_10 = item.data.dimensions) === null || _10 === void 0 ? void 0 : _10.height) || 0);
                    _newX = posX;
                    _newY = posY;
                    // bounding box update
                    x1 = Math.min(x1, _newX);
                    y1 = Math.min(y1, _newY);
                    x2 = Math.max(x2, _newX + width);
                    y2 = Math.max(y2, _newY + height);
                }
            }
            if (_toolData.includes('analog')) {
                var item = manipulative.find(function (m) { return m.data.id === _toolData; });
                if (!item)
                    return; // id not found
                if (item.data.type === 'analog') {
                    var _newX = void 0, _newY = void 0, width = void 0, height = void 0;
                    var posX = Number(((_11 = item.data.center) === null || _11 === void 0 ? void 0 : _11.x) || 0);
                    var posY = Number(((_12 = item.data.center) === null || _12 === void 0 ? void 0 : _12.y) || 0);
                    width = Number(((_13 = item.data.dimensions) === null || _13 === void 0 ? void 0 : _13.width) || 0);
                    height = Number(((_14 = item.data.dimensions) === null || _14 === void 0 ? void 0 : _14.height) || 0);
                    _newX = posX;
                    _newY = posY;
                    // bounding box update
                    x1 = Math.min(x1, _newX);
                    y1 = Math.min(y1, _newY);
                    x2 = Math.max(x2, _newX + width);
                    y2 = Math.max(y2, _newY + height);
                }
            }
            if (_toolData.includes('arrayModels')) {
                var item = manipulative.find(function (m) { return m.data.id === _toolData; });
                if (!item)
                    return;
                if (item.data.type === 'arrayModels') {
                    var posX = Number(item.data.center.x || 0);
                    var posY = Number(item.data.center.y || 0);
                    var width = Number(item.data.dimensions.width || 0);
                    var height = Number(item.data.dimensions.height || 0);
                    x1 = Math.min(x1, posX);
                    y1 = Math.min(y1, posY);
                    x2 = Math.max(x2, posX + width);
                    y2 = Math.max(y2, posY + height);
                }
            }
            if (_toolData.includes('numberFrame')) {
                var item = manipulative.find(function (m) { return m.data.id === _toolData; });
                if (!item)
                    return;
                if (item.data.type === 'numberFrames') {
                    var nf = item.data;
                    var posX = Number(nf.center.x || 0);
                    var posY = Number(nf.center.y || 0);
                    var width = Number(nf.dimensions.width || 0);
                    var height = Number(nf.dimensions.height || 0);
                    x1 = Math.min(x1, posX);
                    y1 = Math.min(y1, posY);
                    x2 = Math.max(x2, posX + width);
                    y2 = Math.max(y2, posY + height);
                }
            }
            if (_toolData.includes('counter')) {
                var item = manipulative.find(function (m) { return m.data.id === _toolData; });
                if (!item || item.data.type !== 'counter')
                    return;
                var counter = item.data;
                var posX = Number(((_15 = counter.center) === null || _15 === void 0 ? void 0 : _15.x) || 0);
                var posY = Number(((_16 = counter.center) === null || _16 === void 0 ? void 0 : _16.y) || 0);
                var width = Number((((_17 = counter.dimensions) === null || _17 === void 0 ? void 0 : _17.width) || 0) * (counter.scale || 1));
                var height = Number((((_18 = counter.dimensions) === null || _18 === void 0 ? void 0 : _18.height) || 0) * (counter.scale || 1));
                x1 = Math.min(x1, posX - width / 2);
                y1 = Math.min(y1, posY - height / 2);
                x2 = Math.max(x2, posX + width / 2);
                y2 = Math.max(y2, posY + height / 2);
            }
            if (_toolData.startsWith('coinsAndCounters_')) {
                var item = manipulative.find(function (m) { return m.data.id === _toolData; });
                if (!item || item.data.type !== 'coinsAndCounters')
                    return;
                var cc = item.data;
                var posX = Number(((_19 = cc.center) === null || _19 === void 0 ? void 0 : _19.x) || 0);
                var posY = Number(((_20 = cc.center) === null || _20 === void 0 ? void 0 : _20.y) || 0);
                var w = Number((((_21 = cc.dimensions) === null || _21 === void 0 ? void 0 : _21.width) || 0) * (cc.scale || 1));
                var h = Number((((_22 = cc.dimensions) === null || _22 === void 0 ? void 0 : _22.height) || 0) * (cc.scale || 1));
                x1 = Math.min(x1, posX - w / 2);
                y1 = Math.min(y1, posY - h / 2);
                x2 = Math.max(x2, posX + w / 2);
                y2 = Math.max(y2, posY + h / 2);
            }
            if (_toolData.includes('numberLine')) {
                var item = manipulative.find(function (m) { return m.data.id === _toolData; });
                if (!item || item.data.type !== 'numberLine')
                    return;
                var nl = item.data;
                var cx = Number(nl.center.x || 0);
                var cy = Number(nl.center.y || 0);
                var s = nl.scale || 1;
                var nlPxPerUnit = computePxPerUnit(nl.gridSquaresPerUnit, nl.intervalNum, !!nl.scalingToManipulatives);
                var nlLineW = (nl.endNum - nl.startNum) * nlPxPerUnit;
                var fullW = (nlLineW + 2 * GRID_SIZE) * s;
                var fullH = TOTAL_SVG_HEIGHT * s;
                x1 = Math.min(x1, cx - fullW / 2);
                y1 = Math.min(y1, cy - fullH / 2);
                x2 = Math.max(x2, cx + fullW / 2);
                y2 = Math.max(y2, cy + fullH / 2);
            }
            if (_toolData.includes('jumpBar')) {
                var item = manipulative.find(function (m) { return m.data.id === _toolData; });
                if (!item || item.data.numberLineId === undefined)
                    return;
                var jb = item.data;
                var posX = Number(jb.center.x || 0);
                var posY = Number(jb.center.y || 0);
                var width = Number(jb.width * (jb.scale || 1));
                var height = 60 * (jb.scale || 1);
                x1 = Math.min(x1, posX);
                y1 = Math.min(y1, posY);
                x2 = Math.max(x2, posX + width);
                y2 = Math.max(y2, posY + height);
            }
            if (_toolData.includes('customTick')) {
                var item = manipulative.find(function (m) { return m.data.id === _toolData; });
                if (!item)
                    return;
                var ct = item.data;
                var posX = Number(ct.center.x || 0);
                var posY = Number(ct.center.y || 0);
                x1 = Math.min(x1, posX - 15);
                y1 = Math.min(y1, posY - 25);
                x2 = Math.max(x2, posX + 15);
                y2 = Math.max(y2, posY + 25);
            }
        });
        return { x1: x1, y1: y1, x2: x2, y2: y2, rotation: rotation };
    }, [selectedTool, manipulative, annotations, text, table, shades]);
    var bottomPanelPos = useMemo(function () { return getBottomPannelPosition(); }, [getBottomPannelPosition]);
    // Memoize setupToolButton to avoid recreation
    var setupToolButton = useCallback(function (toolBtn) {
        return toolBtn.map(function (_tool) {
            if (typeof _tool === 'string') {
                var item = __assign(__assign({}, btnConfig[_tool]), { id: _tool });
                // mathtext button active state is controlled externally via collapsibleState
                if (_tool === 'mathtext')
                    item.activeState = true;
                return item;
            }
            return _tool;
        });
    }, [btnConfig]);
    // Memoize getPopupPos to avoid recalculation
    var getPopupPos = useCallback(function () {
        var _a, _b;
        if (((_a = selectedTool[0]) === null || _a === void 0 ? void 0 : _a.includes('text')) || ((_b = selectedTool[0]) === null || _b === void 0 ? void 0 : _b.includes('newMath'))) {
            var ind = Number(selectedTool[0].split('_')[1]);
            var textItem = text[ind];
            if (!textItem)
                return { top: -1000, left: -1000 };
            var _c = textItem.data.position || {}, _d = _c.y, y = _d === void 0 ? 0 : _d, _e = _c.x, x = _e === void 0 ? 0 : _e;
            var h = textItem.data.height || 0;
            var w = textItem.data.lineWidth || 0;
            return { top: y - h / 2 - 65, left: x - w / 2 };
        }
        return { top: -1000, left: -1000 };
    }, [selectedTool, text]);
    var popupPos = useMemo(function () { return getPopupPos(); }, [getPopupPos]);
    // Memoize button configurations to avoid recalculating on every render
    var mathTextButtons = useMemo(function () { return setupToolButton((btnConfigJSON === null || btnConfigJSON === void 0 ? void 0 : btnConfigJSON.mathtext) || []); }, [btnConfigJSON === null || btnConfigJSON === void 0 ? void 0 : btnConfigJSON.mathtext, setupToolButton]);
    var mathKeypadButtons = useMemo(function () { return setupToolButton((btnConfigJSON === null || btnConfigJSON === void 0 ? void 0 : btnConfigJSON.mathKeypad) || []); }, [btnConfigJSON === null || btnConfigJSON === void 0 ? void 0 : btnConfigJSON.mathKeypad, setupToolButton]);
    var mathKeypadBottomButtons = useMemo(function () { return setupToolButton((btnConfigJSON === null || btnConfigJSON === void 0 ? void 0 : btnConfigJSON.mathKeypadBottom) || []); }, [btnConfigJSON === null || btnConfigJSON === void 0 ? void 0 : btnConfigJSON.mathKeypadBottom, setupToolButton]);
    var deleteConf = btnConfig.delete;
    // Render other manipulatives (numberCharts, arrayModel, clocks, numberFrames, protractor, counters)
    var renderOtherManipulatives = useMemo(function () {
        var gameMaterialTypes = new Set(['dice', 'deck_pool', 'spinner', 'coinsAndCounters']);
        // Helper: render a PatternShapesManipulative from raw data
        var renderPS = function (ps) { return (_jsx(PatternShapesManipulative, { id: ps.id, type: "patternShapes", shapeType: ps.shapeType, center: ps.center, rotation: ps.rotation, scale: ps.scale, color: ps.color, lock: ps.lock, groupId: ps.groupId, path: ps.path, isOutline: ps.isOutline, svgW: ps.svgW, svgH: ps.svgH, isStaticOutline: ps.isStaticOutline }, ps.id)); };
        // --- Permanent PS group map (groupId → member IDs) ---
        // PS shapes stay as individual items in manipulativeMerged (never become type:'group').
        // We pre-group them here so we can always render one PatternShapesSelectionGroup per group.
        var psGroupMap = new Map(); // groupId → ordered member IDs
        manipulative.forEach(function (m) {
            var d = m.data;
            if (d.type === 'patternShapes' && d.groupId && !d.isStaticOutline) {
                if (!psGroupMap.has(d.groupId))
                    psGroupMap.set(d.groupId, []);
                psGroupMap.get(d.groupId).push(d.id);
            }
        });
        // --- Multi-select PS IDs (ungrouped standalones + all members of selected permanent groups) ---
        var psIds = [];
        if (selectedTool.length > 1) {
            selectedTool.forEach(function (tid) {
                if (tid.startsWith('manipulativeGroup_')) {
                    // Expand permanent group → collect all its PS member IDs
                    var memberIds = psGroupMap.get(tid);
                    if (memberIds)
                        psIds.push.apply(psIds, memberIds);
                }
                else {
                    // Standalone ungrouped PS shape
                    var item = manipulative.find(function (m) { return m.data.id === tid; });
                    if ((item === null || item === void 0 ? void 0 : item.data.type) === 'patternShapes' && !item.data.isStaticOutline)
                        psIds.push(tid);
                }
            });
        }
        var selectedPsIdSet = new Set(psIds);
        // Helper: emit ungrouped multi-select SelectionGroup with member shapes as children
        var renderMultiSelectGroup = function () { return (_jsx(PatternShapesSelectionGroup, { selectedShapeIds: psIds, children: psIds.map(function (psId) {
                var item = manipulative.find(function (m) { return m.data.id === psId; });
                if (!item)
                    return null;
                return renderPS(item.data);
            }) }, "ps-selection-group")); };
        // Track which permanent PS groups have been emitted already
        var emittedPsGroups = new Set();
        var multiSelectGroupEmitted = false;
        // NMP groups stay as flat items (same constraint as PS); we render a
        // sibling SelectionGroup overlay for each NMP group so it has a single
        // tab stop, group-wide menu actions, and a bounding-box outline.
        var nmpGroupMap = new Map();
        manipulative.forEach(function (m) {
            var d = m.data;
            if ((d.type === 'numberPiece' || d.type === 'moneyPiece') && d.groupId) {
                if (!nmpGroupMap.has(d.groupId))
                    nmpGroupMap.set(d.groupId, []);
                nmpGroupMap.get(d.groupId).push(m);
            }
        });
        var emittedNmpGroups = new Set();
        // ColoredTiles groups (same constraint as NMP/PS): members stay flat; we
        // render one sibling SelectionGroup overlay per group for a single Tab stop,
        // single highlight, and group-wide menu/scale/move actions. LinearPieces
        // snapped into a CT group share the groupId and are included for bounds/drag.
        var ctGroupMap = new Map();
        manipulative.forEach(function (m) {
            var d = m.data;
            if ((d.type === 'coloredTiles' || d.type === 'linearPiece') && d.groupId) {
                if (!ctGroupMap.has(d.groupId))
                    ctGroupMap.set(d.groupId, []);
                ctGroupMap.get(d.groupId).push(m);
            }
        });
        var emittedCtGroups = new Set();
        // Fraction tiles stay flat (same constraint as NMP/PS/CT): members stay
        // individual items, we render one sibling SelectionGroup overlay per
        // group for a single Tab stop, group-wide menu actions, and drag.
        var ftGroupMap = new Map();
        manipulative.forEach(function (m) {
            var d = m.data;
            if (d.type === 'fractionTiles' && d.groupId) {
                if (!ftGroupMap.has(d.groupId))
                    ftGroupMap.set(d.groupId, []);
                ftGroupMap.get(d.groupId).push(m);
            }
        });
        var emittedFtGroups = new Set();
        var ftGroupOrder = Array.from(ftGroupMap.keys());
        // All user-converted (static) outlines share one Tab stop via a cohort wrapper.
        var staticOutlineItems = manipulative.filter(function (m) { var _a; return ((_a = m === null || m === void 0 ? void 0 : m.data) === null || _a === void 0 ? void 0 : _a.type) === 'patternShapes' && m.data.isStaticOutline; });
        var staticOutlineIdSet = new Set(staticOutlineItems.map(function (m) { return m.data.id; }));
        var staticOutlineCohortEmitted = false;
        return manipulativeMerged.map(function (_data, _index) {
            var _a;
            if (_data.type === 'group') {
                var item = _data;
                var firstMemberType = (_a = item.data[0]) === null || _a === void 0 ? void 0 : _a.type;
                if (!gameMaterialTypes.has(firstMemberType)) {
                    return _jsx(ManipulativeGroup, { id: item.groupId, data: item.data }, item.groupId);
                }
            }
            else {
                var item = _data;
                switch (item.type) {
                    case 'protractor':
                        var _protractorData = item.data;
                        return _jsx(ProtractorManipulative, __assign({}, _protractorData), _protractorData.id);
                    case 'numberCharts':
                        var _numberGrid = item.data;
                        return (_jsx(NumberCharts, { id: "".concat(_numberGrid.id), data: _numberGrid, calledFrom: "widget" }, "".concat(_numberGrid.id)));
                    case 'arrayModel': {
                        var arrayData = item.data;
                        return _jsx(ArrayModel, { data: arrayData }, arrayData.id);
                    }
                    case 'coloredTiles': {
                        var arrayData = item.data;
                        var tile = _jsx(ColoredTiles, { data: arrayData }, arrayData.id);
                        // First member of a ColoredTiles group → also emit the SelectionGroup
                        // overlay sibling so the group has one Tab stop + bounding box.
                        if (arrayData.groupId && !emittedCtGroups.has(arrayData.groupId)) {
                            emittedCtGroups.add(arrayData.groupId);
                            var groupMembers = ctGroupMap.get(arrayData.groupId);
                            return (_jsxs(Fragment, { children: [_jsx(ColoredTilesSelectionGroup, { groupId: arrayData.groupId, members: groupMembers }), tile] }, "".concat(arrayData.groupId, "-with-").concat(arrayData.id)));
                        }
                        return tile;
                    }
                    case 'linearPiece': {
                        var lpData = item.data;
                        return _jsx(LinearPiece, { data: lpData }, lpData.id);
                    }
                    case 'clock':
                        var clockData = item.data;
                        return _jsx(Timer, { _clockData: clockData, isOnWhiteBoard: true }, item.data.id);
                    case 'analog':
                        var _clockData = structuredClone(item.data);
                        return _jsx(AnalogClock, { _clockData: _clockData, isOnWhiteBoard: true }, _clockData.id);
                    case 'numberFrames':
                        var nf = item.data;
                        return _jsx(NumberFrames, { id: nf.id, data: nf }, nf.id);
                    case 'linkingCubes':
                        var lc = item.data;
                        return _jsx(LinkingCubes, { id: lc.id, data: lc, calledFrom: "widget" }, lc.id);
                    case 'numberRacks':
                        var nrData = item.data;
                        return _jsx(NumberRackManipulative, { data: nrData }, nrData.id);
                    case 'patternShapes': {
                        var ps = _data.data;
                        // User-converted outlines share one cohort wrapper (single Tab stop).
                        // Emit once on the first encountered static outline; skip the rest.
                        if (ps.isStaticOutline && staticOutlineIdSet.has(ps.id)) {
                            if (staticOutlineCohortEmitted)
                                return null;
                            staticOutlineCohortEmitted = true;
                            return (_jsx(PatternStaticOutlineCohort, { items: staticOutlineItems, renderItem: renderPS }, "static-outline-cohort"));
                        }
                        // Unified multi-select (2+ items selected): groups + standalones merge into one SelectionGroup
                        if (psIds.length >= 2 && selectedPsIdSet.has(ps.id)) {
                            if (!multiSelectGroupEmitted) {
                                multiSelectGroupEmitted = true;
                                return renderMultiSelectGroup();
                            }
                            return null;
                        }
                        // Single permanent PS group selected — emit one always-in-DOM SelectionGroup per groupId
                        if (ps.groupId && psGroupMap.has(ps.groupId)) {
                            if (!emittedPsGroups.has(ps.groupId)) {
                                emittedPsGroups.add(ps.groupId);
                                var memberIds = psGroupMap.get(ps.groupId);
                                return (_jsx(PatternShapesSelectionGroup, { selectedShapeIds: memberIds, groupId: ps.groupId, children: memberIds.map(function (mid) {
                                        var m = manipulative.find(function (x) { return x.data.id === mid; });
                                        return m ? renderPS(m.data) : null;
                                    }) }, ps.groupId));
                            }
                            return null; // already emitted SelectionGroup for this group
                        }
                        return renderPS(ps);
                    }
                    case 'fractionTiles': {
                        var fractionTileData = item.data;
                        var tile = (_jsx(FractionTileManipulative, __assign({}, fractionTileData), fractionTileData.id));
                        // First member of a fraction-tile group → also emit the
                        // SelectionGroup overlay sibling so the group has one Tab stop
                        // + drag handling.
                        if (fractionTileData.groupId && !emittedFtGroups.has(fractionTileData.groupId)) {
                            emittedFtGroups.add(fractionTileData.groupId);
                            var groupMembers = ftGroupMap.get(fractionTileData.groupId);
                            return (_jsxs(Fragment, { children: [_jsx(FractionTilesSelectionGroup, { groupId: fractionTileData.groupId, members: groupMembers, groupIndex: ftGroupOrder.indexOf(fractionTileData.groupId) + 1, groupCount: ftGroupOrder.length }), tile] }, "".concat(fractionTileData.groupId, "-with-").concat(fractionTileData.id)));
                        }
                        return tile;
                    }
                    case 'numberLine':
                        var nlData = item.data;
                        return _jsx(NumberLineManipulative, { data: nlData }, nlData.id);
                    case 'jumpBar':
                        var jbData = item.data;
                        return _jsx(NumberLineJumpBar, { data: jbData }, jbData.id);
                    case 'customTick':
                        var ctData = item.data;
                        return _jsx(NumberLineCustomTick, { data: ctData }, ctData.id);
                    case 'counter': {
                        // Tray counters render their own image artwork — they never live
                        // inside a NumberFrame, so they get a dedicated component that
                        // skips the frame-snapping logic in <Counter>.
                        var trayItem = item.data;
                        return _jsx(TrayCounter, { id: trayItem.id, data: trayItem }, trayItem.id);
                    }
                    case 'numberFrameCounter':
                        var counterItem = item.data;
                        return _jsx(Counter, { id: counterItem.id, data: counterItem }, counterItem.id);
                    case 'numberPiece':
                    case 'moneyPiece': {
                        var nmpData = item.data;
                        var piece = (_jsx(NumberAndMoneyPieceManipulative, { data: nmpData, isGroup: false }, nmpData.id));
                        // First member of an NMP group → also emit the SelectionGroup
                        // overlay sibling so the group has a tab stop + bounding box.
                        if (nmpData.groupId && !emittedNmpGroups.has(nmpData.groupId)) {
                            emittedNmpGroups.add(nmpData.groupId);
                            var groupMembers = nmpGroupMap.get(nmpData.groupId);
                            return (_jsxs(Fragment, { children: [_jsx(NumberAndMoneyPieceSelectionGroup, { groupId: nmpData.groupId, members: groupMembers }), piece] }, "".concat(nmpData.groupId, "-with-").concat(nmpData.id)));
                        }
                        return piece;
                    }
                }
            }
        });
    }, [manipulativeMerged, selectedTool, manipulative]);
    // Render game materials (dice, spinner, cards, coinsAndCounters)
    var renderGameMaterials = useMemo(function () {
        var gameMaterialTypes = new Set(['dice', 'deck_pool', 'spinner', 'coinsAndCounters']);
        // CC groups: always render one CoinsAndCountersGroupOverlay per group (wrapping
        // members as children) so every group has a persistent Tab stop regardless of
        // selection state — mirrors the PatternShapesSelectionGroup always-in-DOM pattern.
        var ccGroupMap = new Map();
        manipulative.forEach(function (m) {
            var d = m.data;
            if (d.type === 'coinsAndCounters' && d.groupId) {
                if (!ccGroupMap.has(d.groupId))
                    ccGroupMap.set(d.groupId, []);
                ccGroupMap.get(d.groupId).push(m);
            }
        });
        var emittedCcGroups = new Set();
        return manipulativeMerged.map(function (_data, _index) {
            var _a;
            if (_data.type === 'group') {
                var item = _data;
                var firstMemberType = (_a = item.data[0]) === null || _a === void 0 ? void 0 : _a.type;
                if (gameMaterialTypes.has(firstMemberType)) {
                    return _jsx(ManipulativeGroup, { id: item.groupId, data: item.data }, item.groupId);
                }
            }
            else {
                var item = _data;
                switch (item.type) {
                    case 'dice':
                        var _dice = item.data;
                        return (_jsx(DiceManipulative, { id: "".concat(_dice.id), type: _dice.type, diceType: _dice.diceType, center: _dice.center, scale: _dice.scale, dimensions: _dice.dimensions, defaultDimensions: _dice.defaultDimensions, faces: _dice.faces, activeFaceIndex: _dice.activeFaceIndex, color: _dice.color, lock: _dice.lock, label: _dice.label }, "".concat(_dice.id)));
                    case 'deck_pool':
                        var _deckPool = item.data;
                        return (_jsx(CardManipulative, { id: _deckPool.id, cards: _deckPool.cards, rotate: _deckPool.rotate, lock: _deckPool.lock, center: _deckPool.center, dimensions: _deckPool.dimensions, scale: _deckPool.scale, deckType: _deckPool.deckType, deckIdx: _deckPool.deckIdx, gradeIdx: _deckPool.gradeIdx, label: _deckPool.label, backImage: _deckPool.backImage, hideEmptyDeck: _deckPool.hideEmptyDeck, infiniteCard: _deckPool.infiniteCard, deckSizeOnly: _deckPool.deckSizeOnly }, _deckPool.id));
                    case 'spinner':
                        var _spinner = item.data;
                        return (_jsx(SpinnerManipulative, { id: "".concat(_spinner.id), data: _spinner, showOperator: false, calledFrom: "widget" }, "".concat(_spinner.id)));
                    case 'coinsAndCounters': {
                        var ccData = item.data;
                        if (ccData.groupId && ccGroupMap.has(ccData.groupId)) {
                            if (emittedCcGroups.has(ccData.groupId))
                                return null;
                            emittedCcGroups.add(ccData.groupId);
                            var memberItems = ccGroupMap.get(ccData.groupId);
                            return (_jsx(CoinsAndCountersGroupOverlay, { members: memberItems, groupId: ccData.groupId, children: memberItems.map(function (m) { return (_jsx(CoinsAndCountersManipulative, { data: m.data }, m.data.id)); }) }, ccData.groupId));
                        }
                        return _jsx(CoinsAndCountersManipulative, { data: ccData }, ccData.id);
                    }
                }
            }
        });
    }, [manipulativeMerged, manipulative]);
    /**
     * Capture screenshot of the mainHolder div
     * @returns Promise<string> - Data URL of the captured image
     */
    // A capture mutates `.mainHolder`'s style (zoom pinned to scale(1)) and puts
    // it back when it finishes. A second capture started while the first is still
    // running would snapshot that already-neutralised style and "restore" it —
    // permanently losing the board's zoom. Double-tapping Copy Image, or Download
    // immediately followed by Copy, does exactly that, so share the one in-flight
    // capture instead of starting a second.
    var captureInFlightRef = useRef(null);
    var captureMainHolderScreenshot = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var run;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (captureInFlightRef.current)
                        return [2 /*return*/, captureInFlightRef.current];
                    run = withBusy(function () { return __awaiter(void 0, void 0, void 0, function () {
                        var mainHolderElement, _t, _restore, neutralise, _restoreClasses, dropClass, _suppress, focused, _loop_1, el, width, height, SAFARI_MAX_PIXELS, pixelRatio, area, captureOpts, svgUrl, dataUrl, effectivePixelRatio, composited, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    mainHolderElement = document.querySelector('.mainHolder');
                                    if (!mainHolderElement)
                                        return [2 /*return*/, null];
                                    _t = mainHolderElement.getAttribute('style');
                                    // Neutralise the canvas zoom so we capture at natural size, and drop the
                                    // mainHolder's own GPU/3D compositing hints in the same pass (see below).
                                    mainHolderElement.setAttribute('style', (_t ? _t + ';' : '') +
                                        'transform: scale(1); will-change: auto; backface-visibility: visible;');
                                    _restore = new Map();
                                    neutralise = function (el, styles) {
                                        if (!_restore.has(el))
                                            _restore.set(el, el.getAttribute('style'));
                                        Object.assign(el.style, styles);
                                    };
                                    _restoreClasses = [];
                                    dropClass = function (el, cls) {
                                        if (!el.classList.contains(cls))
                                            return;
                                        el.classList.remove(cls);
                                        _restoreClasses.push([el, cls]);
                                    };
                                    // (1) Canvas layer wrappers — the ancestor context that drops CSS backgrounds.
                                    mainHolderElement
                                        .querySelectorAll('.moveableCanvas, .domCanvas')
                                        .forEach(function (el) {
                                        return neutralise(el, { willChange: 'auto', backfaceVisibility: 'visible', transform: 'none' });
                                    });
                                    // (2) Flip cards — flatten the 3D context so the visible face (the hidden
                                    //     one is removed by `filter` below) paints flat and unmirrored.
                                    mainHolderElement
                                        .querySelectorAll('.cardWrapperPerspective')
                                        .forEach(function (el) { return neutralise(el, { perspective: 'none' }); });
                                    mainHolderElement
                                        .querySelectorAll('.cardWrapper')
                                        .forEach(function (el) { return neutralise(el, { transform: 'none', transformStyle: 'flat', willChange: 'auto' }); });
                                    mainHolderElement
                                        .querySelectorAll('.cardFace')
                                        .forEach(function (el) { return neutralise(el, { backfaceVisibility: 'visible', transform: 'none' }); });
                                    _suppress = [];
                                    mainHolderElement.querySelectorAll('*').forEach(function (el) {
                                        var cs = window.getComputedStyle(el);
                                        var styles = {};
                                        // The accent glow, in each of the three forms widgets paint it in.
                                        if (accentMatches(cs.boxShadow))
                                            styles.boxShadow = 'none';
                                        if (accentMatches(cs.filter))
                                            styles.filter = 'none';
                                        // Pattern Shapes draw theirs as an SVG <path> stroked in the accent and
                                        // blurred through a filter — a sibling of the shape itself, so hiding
                                        // the path removes only the glow.
                                        if (accentMatches(cs.stroke))
                                            styles.display = 'none';
                                        // Group bounding boxes (border color is otherwise left alone — it is
                                        // content on tables, shades and the Show-product frame).
                                        if (SELECTION_OUTLINE_CLASSES.some(function (c) { return el.classList.contains(c); })) {
                                            styles.borderColor = 'transparent';
                                            styles.boxShadow = 'none';
                                        }
                                        if (Object.keys(styles).length === 0)
                                            return;
                                        // These overlays animate border-color/box-shadow, so an un-frozen
                                        // transition would still be mid-fade when the clone is built below.
                                        styles.transition = 'none';
                                        _suppress.push([el, styles]);
                                    });
                                    // (3a2) Fraction tile bottom/right edges: box-shadow -> real border.
                                    //
                                    //   WebKit INVERTS THE SIGN OF A BOX-SHADOW'S Y OFFSET when it rasterises
                                    //   the html-to-image <foreignObject> clone (X offsets are unaffected).
                                    //   `.fraction-tile-manipulative-rect-inner` has `border-right: none;
                                    //   border-bottom: none` and paints those two edges with box-shadow so the
                                    //   line lands OUTSIDE the border box and coincides with the neighbouring
                                    //   tile's real border — one separator between glued tiles instead of two
                                    //   (src/styles/widgets/fractionTileManipulative.scss). Its `3px 0` right
                                    //   edge therefore survives the capture, while its `0 3px` bottom edge is
                                    //   drawn 3px ABOVE the box, hidden behind the real 3px `border-top`. Net
                                    //   effect: the tile captures with an open bottom, and nothing looks
                                    //   doubled — which is why it reads as "the bottom edge is cut off".
                                    //   Measured on the webkit-ipad project: bottom-edge border pixels
                                    //   423 (Chromium) vs 0 (WebKit); top/left/right identical in both.
                                    //
                                    //   A real border rasterises correctly in the same clone, so swap to one
                                    //   and keep the geometry EXACT rather than approximating:
                                    //     - width/height grow by the edge width, so the border paints where
                                    //       the shadow did (box-sizing is border-box, so the CONTENT box is
                                    //       unchanged and the centred label does not move);
                                    //     - a negative margin of the same size cancels that growth, so a
                                    //       stack of tiles in the flex-column wrapper does not shift down
                                    //       cumulatively. The element sets no margin of its own.
                                    //   Unconditional, not WebKit-gated: the swap is geometrically identical
                                    //   to what Chromium already captures, so one code path covers both.
                                    //   Restored in `finally` via `_restore` like every other mutation here.
                                    //
                                    //   Scoped deliberately to this one class. A blanket "rewrite every
                                    //   positive-Y box-shadow" pass would also rewrite legitimate soft
                                    //   drop-shadows (a visual change to captures) and would add per-element
                                    //   cost inside the time-sensitive Safari clipboard gesture.
                                    mainHolderElement
                                        .querySelectorAll('.fraction-tile-manipulative-rect-inner')
                                        .forEach(function (el) {
                                        var cs = window.getComputedStyle(el);
                                        // The shadow width tracks the border width ($fraction-border-width-bold
                                        // draws both), so read it off the border that IS present.
                                        var edge = parseFloat(cs.borderTopWidth);
                                        if (!edge || cs.boxShadow === 'none')
                                            return;
                                        var color = cs.borderTopColor;
                                        // Border-box dimensions, and they must be FRACTIONAL. A tile's size is
                                        // `base * tileScale` (src/constants/fractionConfig.ts — the rectangle
                                        // base is 82.5 x 55), so eighths/twelfths at a non-1 scale land on
                                        // values like 41.25px. `offsetWidth`/`offsetHeight` round to the
                                        // nearest integer, and pinning a rounded value back as an explicit
                                        // width/height would paint the tile up to 0.5px wider/taller than it
                                        // is on screen — which the negative margin does NOT cancel, since that
                                        // only offsets the nominal edge. Between two glued tiles the two
                                        // errors add, thickening the shared separator. getBoundingClientRect
                                        // is fractional, and `.mainHolder` is already pinned to scale(1)
                                        // above, so these are natural-size values.
                                        // CAVEAT: this is the AXIS-ALIGNED bounding box. No ancestor of
                                        // rect-inner is rotated today — a fraction tile's `rotation` drives
                                        // CIRCLE sector geometry (SVG + clip-path), and the only CSS `rotate`
                                        // is on the label INSIDE a circle tile, a descendant. If a rect tile
                                        // ever gains a rotated ancestor, the rect becomes the AABB rather than
                                        // the tile's own box and the pinned width/height would distort it in
                                        // the capture; read the border-box size off `cs` instead at that point.
                                        var rect = el.getBoundingClientRect();
                                        var w = rect.width;
                                        var h = rect.height;
                                        _suppress.push([
                                            el,
                                            {
                                                boxShadow: 'none',
                                                borderRight: "".concat(edge, "px solid ").concat(color),
                                                borderBottom: "".concat(edge, "px solid ").concat(color),
                                                width: "".concat(w + edge, "px"),
                                                height: "".concat(h + edge, "px"),
                                                marginRight: "".concat(-edge, "px"),
                                                marginBottom: "".concat(-edge, "px"),
                                            },
                                        ]);
                                    });
                                    // (3b) Selection state painted in #293273, or on `border-color` /
                                    //      `outline` / `box-shadow` where the colour rules cannot help because
                                    //      the same properties carry real content elsewhere. Handled by
                                    //      dropping the modifier class, so the unselected appearance comes back
                                    //      exactly rather than being approximated with a replacement value.
                                    SELECTION_STATE_CLASSES.forEach(function (cls) {
                                        var scope = GENERIC_STATE_CLASS_SCOPE[cls];
                                        var selector = scope ? "".concat(scope, ".").concat(cls) : ".".concat(cls);
                                        mainHolderElement.querySelectorAll(selector).forEach(function (el) { return dropClass(el, cls); });
                                    });
                                    // (3c) Outline-only affordances on elements that ARE content, so they can
                                    //      never be dropped by class — clear just the outline.
                                    SELECTION_OUTLINE_ONLY_SELECTORS.forEach(function (sel) {
                                        mainHolderElement.querySelectorAll(sel).forEach(function (el) {
                                            neutralise(el, {});
                                            el.style.setProperty('outline', 'none', 'important');
                                        });
                                    });
                                    focused = document.activeElement;
                                    if (focused && mainHolderElement.contains(focused)) {
                                        neutralise(focused, {});
                                        focused.style.setProperty('outline', 'none', 'important');
                                        // Some focus rules round the element's corners alongside the outline —
                                        // `button.gridParent:focus-visible` in numberCharts.scss and the spinner's
                                        // two `:focus-visible` blocks all set `border-radius` in the same block.
                                        // Stripping only the outline left the radius applied, so the widget's own
                                        // border captured with rounded corners while focused and square corners
                                        // otherwise (measured at 89 diff px on NumberCharts' cyan
                                        // `border: 10px solid rgb(14,154,178)`). Scoped to `:focus-visible`,
                                        // because that is the state those rules key on — an element that is
                                        // focused but not focus-visible has no ring and no added radius, and
                                        // resetting its radius could flatten genuinely rounded content.
                                        try {
                                            if (focused.matches(':focus-visible')) {
                                                focused.style.setProperty('border-radius', '0', 'important');
                                            }
                                        }
                                        catch (_c) {
                                            // :focus-visible is unsupported in some engines (and in jsdom, where
                                            // `matches` throws on it) — the outline strip above still applies.
                                        }
                                        _loop_1 = function (el) {
                                            var outlineColor = window.getComputedStyle(el).outlineColor;
                                            if (FOCUS_RING_RGB.some(function (c) { return outlineColor.includes(c); })) {
                                                neutralise(el, {});
                                                el.style.setProperty('outline', 'none', 'important');
                                            }
                                        };
                                        // Several widgets paint the ring on an ANCESTOR via `:focus-within` /
                                        // `:has(:focus-visible)` (ColoredTiles, Spinner, NumberCharts) rather
                                        // than on the focused node itself. Walk up and strip those too — but
                                        // only when the outline is one of the app's focus-ring colors, since an
                                        // ancestor's outline can be content (the ColoredTiles grid's own
                                        // `outline: 5px solid #0c9bb3` sits on such an ancestor).
                                        for (el = focused.parentElement; el && el !== mainHolderElement; el = el.parentElement) {
                                            _loop_1(el);
                                        }
                                    }
                                    _suppress.forEach(function (_a) {
                                        var el = _a[0], styles = _a[1];
                                        return neutralise(el, styles);
                                    });
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([1, 7, 8, 9]);
                                    width = mainHolderElement.offsetWidth || mainHolderElement.scrollWidth;
                                    height = mainHolderElement.offsetHeight || mainHolderElement.scrollHeight;
                                    SAFARI_MAX_PIXELS = 16 * 1024 * 1024;
                                    pixelRatio = 2;
                                    area = Math.max(1, width * height);
                                    if (area * pixelRatio * pixelRatio > SAFARI_MAX_PIXELS) {
                                        pixelRatio = Math.max(1, Math.sqrt(SAFARI_MAX_PIXELS / area));
                                    }
                                    captureOpts = {
                                        quality: 1.0,
                                        pixelRatio: pixelRatio,
                                        backgroundColor: '#ffffff',
                                        // Explicit size + pinned clone box: without these Safari can't infer
                                        // the node size from the cloned SVG <foreignObject> and collapses the
                                        // output to 1x1.
                                        width: width,
                                        height: height,
                                        style: {
                                            transform: 'scale(1)',
                                            transformOrigin: 'top left',
                                            width: "".concat(width, "px"),
                                            height: "".concat(height, "px"),
                                        },
                                        // Control exactly which nodes html-to-image clones. Returning false
                                        // means the node (and its subtree) is never cloned — the only
                                        // reliable way to drop content, since html-to-image can't be trusted
                                        // to honor `display:none` / `backface-visibility` in its clone
                                        // (Safari's computed-style cssText is empty, so those styles don't
                                        // survive the clone).
                                        filter: function (node) {
                                            if (!(node instanceof Element))
                                                return true;
                                            // (a) Freehand <canvas> + Raphael SVG layers — html-to-image drops
                                            //     them on iOS; composited back on top by
                                            //     compositeAnnotationLayers() below.
                                            if (ANNOTATION_LAYER_CLASSES.some(function (c) { return node.classList.contains(c); })) {
                                                return false;
                                            }
                                            // (a2) Selection-only chrome: resizer border + handles, the
                                            //      floating tool panel, rotate / drag handles, the lasso and
                                            //      the on-canvas group pickers. These render inside
                                            //      `.mainHolder` but are not part of the saved workspace.
                                            if (SELECTION_CHROME_CLASSES.some(function (c) { return node.classList.contains(c); })) {
                                                return false;
                                            }
                                            // (b) The card face that isn't showing. Both faces always exist in
                                            //     the DOM; the hidden `.backface` is mirrored (rotateY(180)) and
                                            //     would otherwise paint over the front, capturing the card
                                            //     "flipped". Keep only the visible face: back when flipped,
                                            //     front otherwise.
                                            if (node.classList.contains('cardFace')) {
                                                var wrapper = node.closest('.cardWrapper');
                                                if (wrapper) {
                                                    var flipped = wrapper.classList.contains('isFlipped');
                                                    var isBack = node.classList.contains('backface');
                                                    if (flipped !== isBack)
                                                        return false;
                                                }
                                            }
                                            return true;
                                        },
                                    };
                                    return [4 /*yield*/, htmlToImage.toSvg(mainHolderElement, captureOpts)];
                                case 2:
                                    svgUrl = _b.sent();
                                    if (!svgUrl)
                                        return [2 /*return*/, null];
                                    return [4 /*yield*/, rasterizeCloneSvg(svgUrl, width, height, pixelRatio, captureOpts.backgroundColor)];
                                case 3:
                                    dataUrl = _b.sent();
                                    effectivePixelRatio = pixelRatio;
                                    if (!(!dataUrl && pixelRatio > 1)) return [3 /*break*/, 5];
                                    effectivePixelRatio = 1;
                                    return [4 /*yield*/, rasterizeCloneSvg(svgUrl, width, height, effectivePixelRatio, captureOpts.backgroundColor)];
                                case 4:
                                    dataUrl = _b.sent();
                                    _b.label = 5;
                                case 5:
                                    // Still nothing: report failure rather than hand back a blank PNG for the
                                    // user to save. Losing the old `> 5000 bytes` check left no such guard at
                                    // all, and a physical iPad duly saved a 163-byte file as a success.
                                    if (!dataUrl)
                                        return [2 /*return*/, null];
                                    return [4 /*yield*/, compositeAnnotationLayers(mainHolderElement, dataUrl, width, height, effectivePixelRatio)];
                                case 6:
                                    composited = _b.sent();
                                    return [2 /*return*/, composited || dataUrl];
                                case 7:
                                    _a = _b.sent();
                                    return [2 /*return*/, null];
                                case 8:
                                    // Always restore the original styles, even on early return / throw:
                                    // first the neutralised wrappers, then the mainHolder's own style.
                                    _restore.forEach(function (style, el) {
                                        if (style === null)
                                            el.removeAttribute('style');
                                        else
                                            el.setAttribute('style', style);
                                    });
                                    // …and the selection state classes dropped for the capture. If this were
                                    // skipped, a screenshot would visibly deselect the user's widget.
                                    _restoreClasses.forEach(function (_a) {
                                        var el = _a[0], cls = _a[1];
                                        return el.classList.add(cls);
                                    });
                                    mainHolderElement.setAttribute('style', _t || '');
                                    return [7 /*endfinally*/];
                                case 9: return [2 /*return*/];
                            }
                        });
                    }); });
                    captureInFlightRef.current = run;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, run];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    captureInFlightRef.current = null;
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, []);
    // Approximate PNG byte size from a base64 data-URL (base64 encodes 3 bytes
    // per 4 chars). Used to surface the saved/copied image size in the UI.
    var imageByteSizeFromDataUrl = function (dataUrl) {
        return Math.round((dataUrl.length - (dataUrl.indexOf(',') + 1)) * 0.75);
    };
    // Decode the captured PNG to read its real pixel dimensions. Resolves to
    // 0x0 if the data-URL is not a decodable image (the blank-capture case).
    var measureImageDimensions = function (dataUrl) {
        return new Promise(function (resolve) {
            var img = new Image();
            img.onload = function () { return resolve({ width: img.naturalWidth, height: img.naturalHeight }); };
            img.onerror = function () { return resolve({ width: 0, height: 0 }); };
            img.src = dataUrl;
        });
    };
    /**
     * Download the screenshot of mainHolder div
     * @param filename - Optional filename for the downloaded image (default: 'whiteboard-screenshot.png')
     */
    var downloadMainHolderScreenshot = useCallback(function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (filename) {
            var report, dataUrl, link, bytes, _a, width, height, _b;
            if (filename === void 0) { filename = 'whiteboard-screenshot.png'; }
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        report = function (ok, reason, info) { return customEventHandler.dispatchEvent('screenshotCopied', { ok: ok, reason: reason, info: info }); };
                        return [4 /*yield*/, captureMainHolderScreenshot()];
                    case 1:
                        dataUrl = _c.sent();
                        if (!dataUrl) {
                            report(false);
                            return [2 /*return*/];
                        }
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 4, , 5]);
                        link = document.createElement('a');
                        link.download = filename;
                        link.href = dataUrl;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        bytes = imageByteSizeFromDataUrl(dataUrl);
                        return [4 /*yield*/, measureImageDimensions(dataUrl)];
                    case 3:
                        _a = _c.sent(), width = _a.width, height = _a.height;
                        report(true, undefined, { bytes: bytes, width: width, height: height, mode: 'download' });
                        return [3 /*break*/, 5];
                    case 4:
                        _b = _c.sent();
                        report(false);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, [captureMainHolderScreenshot]);
    /**
     * Copy the screenshot of mainHolder div to clipboard. Reports the outcome
     * via the `screenshotCopied` custom event so UI surfaces (the iwb share
     * menu, the share popup) can render a "image copied" / "an issue occurred"
     * confirmation popup that mirrors the feedback for copy-link / copy-code.
     */
    var copyMainHolderScreenshotToClipboard = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var report, copiedDataUrl_1, copiedBytes_1, dims, _a, _b, dataUrl, response, blob, dims, _c, dataUrl, canvas_1, img_1, _d;
        var _e;
        var _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    report = function (ok, reason, info) {
                        customEventHandler.dispatchEvent('screenshotCopied', { ok: ok, reason: reason, info: info });
                    };
                    // The Clipboard API is only exposed in a secure context (HTTPS or
                    // localhost). Over plain HTTP — e.g. a LAN-IP dev build opened on an iPad —
                    // navigator.clipboard is undefined, so image copy is impossible and
                    // navigator.clipboard.write would throw. Detect this up front and report a
                    // specific reason so the UI can explain it needs HTTPS rather than showing
                    // the generic "copy failed". (In HTTPS production the API is present and
                    // the Safari-synchronous path below runs normally.)
                    if (!((_f = navigator.clipboard) === null || _f === void 0 ? void 0 : _f.write) || typeof ClipboardItem === 'undefined') {
                        report(false, 'insecure');
                        return [2 /*return*/];
                    }
                    if (!(browserDetect.platformIOS() || browserDetect.isSafari())) return [3 /*break*/, 8];
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 6, , 7]);
                    copiedDataUrl_1 = null;
                    copiedBytes_1 = 0;
                    return [4 /*yield*/, navigator.clipboard.write([
                            new ClipboardItem({
                                'image/png': captureMainHolderScreenshot().then(function (dataUrl) {
                                    if (!dataUrl)
                                        return Promise.reject(new Error('capture failed'));
                                    copiedDataUrl_1 = dataUrl;
                                    return fetch(dataUrl)
                                        .then(function (r) { return r.blob(); })
                                        .then(function (blob) {
                                        copiedBytes_1 = blob.size;
                                        return blob;
                                    });
                                }),
                            }),
                        ])];
                case 2:
                    _g.sent();
                    if (!copiedDataUrl_1) return [3 /*break*/, 4];
                    return [4 /*yield*/, measureImageDimensions(copiedDataUrl_1)];
                case 3:
                    _a = _g.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _a = { width: 0, height: 0 };
                    _g.label = 5;
                case 5:
                    dims = _a;
                    report(true, undefined, __assign(__assign({ bytes: copiedBytes_1 }, dims), { mode: 'copy' }));
                    return [3 /*break*/, 7];
                case 6:
                    _b = _g.sent();
                    report(false);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
                case 8:
                    _g.trys.push([8, 14, , 19]);
                    return [4 /*yield*/, captureMainHolderScreenshot()];
                case 9:
                    dataUrl = _g.sent();
                    if (!dataUrl) {
                        report(false);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, fetch(dataUrl)];
                case 10:
                    response = _g.sent();
                    return [4 /*yield*/, response.blob()];
                case 11:
                    blob = _g.sent();
                    return [4 /*yield*/, navigator.clipboard.write([new ClipboardItem((_e = {}, _e[blob.type] = blob, _e))])];
                case 12:
                    _g.sent();
                    return [4 /*yield*/, measureImageDimensions(dataUrl)];
                case 13:
                    dims = _g.sent();
                    report(true, undefined, __assign(__assign({ bytes: blob.size }, dims), { mode: 'copy' }));
                    return [3 /*break*/, 19];
                case 14:
                    _c = _g.sent();
                    _g.label = 15;
                case 15:
                    _g.trys.push([15, 17, , 18]);
                    return [4 /*yield*/, captureMainHolderScreenshot()];
                case 16:
                    dataUrl = _g.sent();
                    if (!dataUrl) {
                        report(false);
                        return [2 /*return*/];
                    }
                    canvas_1 = document.createElement('canvas');
                    img_1 = new Image();
                    img_1.onload = function () { return __awaiter(void 0, void 0, void 0, function () {
                        var ctx;
                        return __generator(this, function (_a) {
                            canvas_1.width = img_1.width;
                            canvas_1.height = img_1.height;
                            ctx = canvas_1.getContext('2d');
                            if (ctx) {
                                ctx.drawImage(img_1, 0, 0);
                                canvas_1.toBlob(function (blob) { return __awaiter(void 0, void 0, void 0, function () {
                                    var _a;
                                    var _b;
                                    return __generator(this, function (_c) {
                                        switch (_c.label) {
                                            case 0:
                                                if (!blob) return [3 /*break*/, 5];
                                                _c.label = 1;
                                            case 1:
                                                _c.trys.push([1, 3, , 4]);
                                                return [4 /*yield*/, navigator.clipboard.write([new ClipboardItem((_b = {}, _b[blob.type] = blob, _b))])];
                                            case 2:
                                                _c.sent();
                                                report(true, undefined, {
                                                    bytes: blob.size,
                                                    width: canvas_1.width,
                                                    height: canvas_1.height,
                                                    mode: 'copy',
                                                });
                                                return [3 /*break*/, 4];
                                            case 3:
                                                _a = _c.sent();
                                                report(false);
                                                return [3 /*break*/, 4];
                                            case 4: return [3 /*break*/, 6];
                                            case 5:
                                                report(false);
                                                _c.label = 6;
                                            case 6: return [2 /*return*/];
                                        }
                                    });
                                }); });
                            }
                            else {
                                report(false);
                            }
                            return [2 /*return*/];
                        });
                    }); };
                    img_1.onerror = function () { return report(false); };
                    img_1.src = dataUrl;
                    return [3 /*break*/, 18];
                case 17:
                    _d = _g.sent();
                    report(false);
                    return [3 /*break*/, 18];
                case 18: return [3 /*break*/, 19];
                case 19: return [2 /*return*/];
            }
        });
    }); }, [captureMainHolderScreenshot]);
    // Expose functions to window for easy access
    useEffect(function () {
        if (typeof window !== 'undefined') {
            window.captureMainHolderScreenshot = captureMainHolderScreenshot;
            window.downloadMainHolderScreenshot = downloadMainHolderScreenshot;
            window.copyMainHolderScreenshotToClipboard = copyMainHolderScreenshotToClipboard;
        }
        return function () {
            if (typeof window !== 'undefined') {
                delete window.captureMainHolderScreenshot;
                delete window.downloadMainHolderScreenshot;
                delete window.copyMainHolderScreenshotToClipboard;
            }
        };
    }, [
        captureMainHolderScreenshot,
        downloadMainHolderScreenshot,
        copyMainHolderScreenshotToClipboard,
    ]);
    var handleTextLockedClick = useCallback(function (idx) {
        setSelectedTool(["text_".concat(idx)]);
    }, [setSelectedTool]);
    var renderedText = useMemo(function () {
        return text.map(function (dta, idx) {
            var _a, _b;
            return (_jsx(MathEditor, { setActiveLink: setActiveLink, data: dta, index: idx, idPreffix: 'text', bottomButtons: mathTextButtons, keypadButtons: mathKeypadButtons, bottomBtns: mathKeypadBottomButtons, throwChangeOnBlur: true, viewonly: (_b = (_a = dta.data.lock) === null || _a === void 0 ? void 0 : _a.editing) !== null && _b !== void 0 ? _b : false, selectOnViewOnly: true, onClickWhenLocked: handleTextLockedClick, enableFocusPanel: true }, idx));
        });
    }, [text, mathTextButtons, mathKeypadButtons, mathKeypadBottomButtons, handleTextLockedClick]);
    var renderedTables = useMemo(function () { return table.map(function (dta, idx) { return _jsx(TableManipulativeComp, { tabledata: dta, index: idx }, idx); }); }, [table]);
    var renderedShades = useMemo(function () {
        return shades.map(function (_data, _index) { return (_jsx(Shades, { id: "".concat(_data.id, "_").concat(_index), type: _data.type, data: _data.data }, _data.id)); });
    }, [shades]);
    var onScrollChange = useCallback(function (scrollTop, scrollLeft) {
        setRecenterPanOffset({ x: scrollLeft, y: scrollTop });
    }, [setRecenterPanOffset]);
    return (_jsxs("div", { ref: whiteboardRef, className: "whitepaper ".concat(displayMode === 'smartBoard' && 'fullwidth'), role: "application", "aria-label": panningEnable ? t('text.panningModeLabel') : t('text.canvasLabel'), "aria-roledescription": panningEnable ? t('text.scrollableCanvas') : undefined, tabIndex: -1, onContextMenu: function (e) {
            var target = e.target;
            var manipulativeEl = target.closest('[data-manipulative-id]');
            if (manipulativeEl) {
                e.preventDefault();
                var clickedId_1 = manipulativeEl.getAttribute('data-manipulative-id');
                // If clicked element is inside a group, use the group's ID for context menu
                if (clickedId_1) {
                    var groupEl = manipulativeEl.closest('[data-manipulative-id^="manipulativeGroup_"]');
                    if (groupEl && groupEl !== manipulativeEl) {
                        clickedId_1 = groupEl.getAttribute('data-manipulative-id');
                    }
                }
                // ColoredTiles / LinearPiece / NMP members render individually (their
                // group's SelectionGroup overlay is a sibling, not a DOM ancestor), so
                // the ancestor check above can't find the group. Resolve a grouped
                // member to its groupId so the context menu acts on the whole group
                // (move/scale/ungroup/delete).
                if (clickedId_1 && !clickedId_1.startsWith('manipulativeGroup_')) {
                    var clickedItem = manipulative.find(function (m) { return m.data.id === clickedId_1; });
                    var cd = clickedItem === null || clickedItem === void 0 ? void 0 : clickedItem.data;
                    if (cd &&
                        (cd.type === 'coloredTiles' ||
                            cd.type === 'linearPiece' ||
                            cd.type === 'numberPiece' ||
                            cd.type === 'moneyPiece') &&
                        cd.groupId) {
                        clickedId_1 = cd.groupId;
                    }
                }
                if (clickedId_1) {
                    // Select the right-clicked manipulative if not already selected
                    if (!selectedTool.includes(clickedId_1)) {
                        setSelectedTool([clickedId_1]);
                    }
                    setContextMenu({
                        x: e.clientX,
                        y: e.clientY,
                        manipulativeId: clickedId_1,
                    });
                }
                return;
            }
            // Right-click on annotation (SVG elements inside raphaelCanvas)
            if (target instanceof SVGElement || target.closest('svg')) {
                var annId = selectedTool.find(function (s) { return s.startsWith('annotations_'); });
                if (annId) {
                    e.preventDefault();
                    setContextMenu({
                        x: e.clientX,
                        y: e.clientY,
                        manipulativeId: annId,
                    });
                }
            }
        }, children: [_jsx(CustomScrollbar, { ref: scrollRef, hideMouseScroll: true, onChange: onScrollChange, className: "whiteboardScrollbar", children: _jsx("div", { id: 'wrapperDiv', ref: wrapperDiv, className: panningEnable ? "panningMode".concat(isDraggingState ? ' dragging' : '') : '', style: {
                        width: "".concat(Math.max(1, canvasWidth * zoomLevel), "px"),
                        height: "".concat(Math.max(1, canvasHeight * zoomLevel), "px"),
                        position: 'relative',
                        boxSizing: 'border-box',
                        margin: 'auto',
                        WebkitUserSelect: 'none',
                        WebkitTouchCallout: 'none',
                        WebkitTapHighlightColor: 'transparent',
                        userSelect: 'none',
                    }, children: _jsxs("div", { style: {
                            width: "".concat(canvasWidth, "px"),
                            height: "".concat(canvasHeight, "px"),
                            transform: "scale(".concat(zoomLevel, ")"),
                        }, ref: mainBoardRef, className: "mainHolder".concat([leftSideTools.pen, leftSideTools.highlighter, leftSideTools.eraser].includes(tool)
                            ? ' drawing-active'
                            : ''), onDragOver: function (e) {
                            // Allow tray-counter drops only — accept the drag so onDrop fires.
                            if (e.dataTransfer.types.includes('application/x-tray-counter')) {
                                e.preventDefault();
                                e.dataTransfer.dropEffect = 'copy';
                            }
                        }, onDrop: function (e) {
                            var counterId = e.dataTransfer.getData('application/x-tray-counter');
                            if (!counterId)
                                return;
                            e.preventDefault();
                            // Convert viewport-relative drop coords to canvas coords.
                            // mainHolder has `transform: scale(zoomLevel)` so its visual
                            // size is `canvas * zoomLevel`. Dividing by zoomLevel maps the
                            // drop point back to logical canvas coordinates.
                            var rect = e.currentTarget.getBoundingClientRect();
                            var canvasX = (e.clientX - rect.left) / zoomLevel;
                            var canvasY = (e.clientY - rect.top) / zoomLevel;
                            customEventHandler.dispatchEvent('trayCounterDrop', {
                                counterId: counterId,
                                position: { x: canvasX, y: canvasY },
                            });
                        }, children: [(function () {
                                var _a, _b, _c, _d;
                                // Pick the language-specific PDF (e.g. the Spanish background from
                                // translations.es.pages) when one exists for this page, falling
                                // back to the default English background otherwise.
                                var page = pageData[currentPage - 1];
                                var bg = resolvePageBackground(page, language, activityMeta === null || activityMeta === void 0 ? void 0 : activityMeta.translations);
                                if (!bg)
                                    return null;
                                return (_jsx(BackgroundRenderer, { file: bg, diffX: (_a = page.bgOffset) === null || _a === void 0 ? void 0 : _a.diffX, diffY: (_b = page.bgOffset) === null || _b === void 0 ? void 0 : _b.diffY, pageWidth: (_c = page.bgOffset) === null || _c === void 0 ? void 0 : _c.pageWidth, pageHeight: (_d = page.bgOffset) === null || _d === void 0 ? void 0 : _d.pageHeight }));
                            })(), _jsx(BackgroundPatternCanvas, {}, "backgroundPatternCanvas"), _jsx(SelectionLayer, { onSelectionStart: setSelectionDim }), _jsxs("div", { style: { width: canvasWidth, height: canvasHeight }, className: "moveableCanvas", children: [renderOtherManipulatives, renderedTables, renderedText] }), _jsx(DomCanvas, {}, "domCanvas"), _jsx(RaphaelCanvas, {}, "raphaelCanvas"), _jsx(DrawCanvas, { ref: drawCanvasRef }, "drawCanvas"), _jsxs("div", { style: { width: canvasWidth, height: canvasHeight }, className: "moveableCanvas", children: [renderGameMaterials, renderedShades] }), _jsx(LinkingCubePicker, {}), _jsx(ColoredTilesCellPicker, {}), _jsx(ColoredTilesLinkPicker, {}), _jsx(LinearPieceSnapPicker, {}), _jsx(PatternShapeLinkPicker, {}), _jsx(CoinsAndCountersLinkPicker, {}), _jsx(NumberAndMoneyPiecePicker, {}), _jsx(NumberAndMoneyPieceGroupPicker, {}), _jsx(FractionTilesGroupPicker, {}), _jsx(ResizerComponent, {}), activeLink && (_jsxs("div", { className: "linkPopup", style: __assign({}, popupPos), tabIndex: -1, onMouseDown: function (e) { return e.preventDefault(); }, children: [_jsx("a", { href: activeLink.startsWith('http://') || activeLink.startsWith('https://')
                                            ? activeLink
                                            : "https://".concat(activeLink), target: "_blank", rel: "noopener noreferrer", children: activeLink }), _jsx("div", { id: "3", className: "dividerLine" }), _jsx(ButtonComponent, { normalCSS: "removeLink", imgSrc: deleteConf.imgSrc, title: deleteConf.ariaLabel, clickHandler: function () {
                                            setShowRemoveLinkConfirm(true);
                                        } }, 'removeLink')] })), toolBtn.length !== 0 &&
                                !hideBottomBar &&
                                !getContentLockArray({ selectedTool: selectedTool, text: text, table: table, annotations: annotations, manipulative: manipulative })
                                    .editing && (_jsx("div", { style: {
                                    '--bottomPanelTool-posX': "".concat(tableToolbarPosOverride && selectedTool.some(function (t) { return t.includes('tableText'); })
                                        ? tableToolbarPosOverride.x1
                                        : bottomPanelPos.x1, "px"),
                                    '--bottomPanelTool-posY': "".concat((tableToolbarPosOverride && selectedTool.some(function (t) { return t.includes('tableText'); })
                                        ? tableToolbarPosOverride.y2
                                        : bottomPanelPos.y2) + 10, "px"),
                                    // '--bottomPanelTool-visible': shadeUpdating ? 0 : 1,
                                }, children: _jsx(BottomPanel, { id: 'bottomPanelTool', toolsBtn: setupToolButton(toolBtn), className: "bottomPanelTool", collapsibleState: mathTextCollapsibleState, tooltipDirection: tableToolbarPosOverride && selectedTool.some(function (t) { return t.includes('tableText'); })
                                        ? tableToolbarPosOverride.aboveCell
                                            ? 'bottom'
                                            : 'top'
                                        : undefined }, 'bottomPanelTool') })), _jsx(SelectionCanvas, { selectionDim: selectionDim }, "selectionCanvas"), selectedTool &&
                                (selectedTool.length > 1 ||
                                    (selectedTool.length === 1 && selectedTool[0].startsWith('manipulativeGroup_'))) &&
                                (function () {
                                    var selectedItems = manipulative.filter(function (m) { var _a; return selectedTool.includes((_a = m.data.id) !== null && _a !== void 0 ? _a : ''); });
                                    if (selectedTool.length === 1 && selectedTool[0].startsWith('manipulativeGroup_')) {
                                        selectedItems = manipulative.filter(function (m) { return m.data.groupId === selectedTool[0]; });
                                    }
                                    var isOutlineGroup = selectedItems.length > 0 &&
                                        selectedItems.every(function (item) { var _a; return ((_a = item.data.lock) === null || _a === void 0 ? void 0 : _a.positioning) === true && item.data.groupId; });
                                    if (isOutlineGroup)
                                        return null;
                                    // Skip if all selected items are pattern shapes — handled by PatternShapesSelectionGroup
                                    var allPatternShapes = selectedItems.length > 0 &&
                                        selectedItems.every(function (item) { return item.data.type === 'patternShapes'; });
                                    if (allPatternShapes)
                                        return null;
                                    if (!(selectedTool.length === 1 && selectedTool[0].startsWith('manipulativeGroup_')) &&
                                        selectedItems.length <= 1)
                                        return null;
                                    var UNIT = 60;
                                    var boxes = selectedItems
                                        .map(function (m) {
                                        var _a;
                                        return ({
                                            c: m.data.center,
                                            s: (_a = m.data.scale) !== null && _a !== void 0 ? _a : 1,
                                        });
                                    })
                                        .map(function (_a) {
                                        var c = _a.c, s = _a.s;
                                        var halfW = (UNIT / 2) * s;
                                        var halfH = (UNIT / 2) * s;
                                        return {
                                            minX: c.x - halfW,
                                            minY: c.y - halfH,
                                            maxX: c.x + halfW,
                                            maxY: c.y + halfH,
                                        };
                                    });
                                    var minX = Math.min.apply(Math, boxes.map(function (b) { return b.minX; }));
                                    var minY = Math.min.apply(Math, boxes.map(function (b) { return b.minY; }));
                                    var maxX = Math.max.apply(Math, boxes.map(function (b) { return b.maxX; }));
                                    var maxY = Math.max.apply(Math, boxes.map(function (b) { return b.maxY; }));
                                    var centerX = (minX + maxX) / 2;
                                    var centerY = (minY + maxY) / 2;
                                    var rotatingRef = { active: false };
                                    var startAngle = 0;
                                    var initialCenters = {};
                                    var initialRotations = {};
                                    var onRotateStart = function (e) {
                                        e.stopPropagation();
                                        var clientX = e.clientX;
                                        var clientY = e.clientY;
                                        startAngle = Math.atan2(clientY - centerY, clientX - centerX);
                                        selectedItems.forEach(function (item) {
                                            var _a;
                                            var iid = item.data.id;
                                            if (!iid)
                                                return;
                                            initialCenters[iid] = {
                                                x: item.data.center.x,
                                                y: item.data.center.y,
                                            };
                                            initialRotations[iid] = (_a = item.data.rotation) !== null && _a !== void 0 ? _a : 0;
                                        });
                                        rotatingRef.active = true;
                                        var onMove = function (me) {
                                            if (!rotatingRef.active)
                                                return;
                                            var curA = Math.atan2(me.clientY - centerY, me.clientX - centerX);
                                            var delta = curA - startAngle; // radians
                                            var degDelta = (delta * 180) / Math.PI;
                                            setManipulative(function (prev) {
                                                return prev.map(function (item) {
                                                    var _a, _b, _c;
                                                    var isSelected = selectedTool.length === 1 &&
                                                        selectedTool[0].startsWith('manipulativeGroup_')
                                                        ? item.data.groupId === selectedTool[0]
                                                        : selectedTool.includes((_a = item.data.id) !== null && _a !== void 0 ? _a : '');
                                                    if (!isSelected)
                                                        return item;
                                                    var iid = (_b = item.data.id) !== null && _b !== void 0 ? _b : '';
                                                    var init = initialCenters[iid];
                                                    var rot = (_c = initialRotations[iid]) !== null && _c !== void 0 ? _c : 0;
                                                    var dx = init.x - centerX;
                                                    var dy = init.y - centerY;
                                                    var cos = Math.cos(delta);
                                                    var sin = Math.sin(delta);
                                                    var nx = centerX + dx * cos - dy * sin;
                                                    var ny = centerY + dx * sin + dy * cos;
                                                    return __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { center: { x: nx, y: ny }, rotation: rot + degDelta }) });
                                                });
                                            });
                                        };
                                        var onUp = function (me) {
                                            if (!rotatingRef.active)
                                                return;
                                            rotatingRef.active = false;
                                            selectedItems.forEach(function (item) {
                                                var old = __assign({}, item);
                                                if (!old.data.id)
                                                    return;
                                                var updated = manipulative.find(function (m) { return m.data.id === old.data.id; }) || item;
                                                saveState({
                                                    type: old.data.id,
                                                    id: old.data.id.split('_')[1],
                                                    propertyName: 'completeData',
                                                    old: JSON.stringify(old),
                                                    new: JSON.stringify(updated),
                                                });
                                            });
                                            window.removeEventListener('mousemove', onMove);
                                            window.removeEventListener('mouseup', onUp);
                                        };
                                        window.addEventListener('mousemove', onMove);
                                        window.addEventListener('mouseup', onUp);
                                    };
                                    return (_jsx("div", { className: "rotateHandle", onMouseDown: onRotateStart, style: { left: (minX + maxX) / 2, top: minY - 24 } }));
                                })()] }) }) }), _jsx(Popup, { isOpen: showRemoveLinkConfirm, onClose: function () { return setShowRemoveLinkConfirm(false); }, ariaLabel: "Confirm remove link", className: "className-eraserPopup", children: _jsx("div", { className: "eraserWrapper", children: _jsxs("div", { className: "container", children: [_jsxs("div", { className: "upperPart", children: [_jsx("div", { className: "title", children: t('text.removeLink') }), _jsxs("div", { className: "btnContainer", children: [_jsx(ButtonComponent, { type: "textType1", text: t('text.cancel'), defaultCSS: "customBtn", normalCSS: "btn", clickHandler: function () { return setShowRemoveLinkConfirm(false); } }), _jsx(ButtonComponent, { type: "textType1", text: t('text.delete'), defaultCSS: "customBtn", normalCSS: "btn", clickHandler: function () {
                                                    customEventHandler.dispatchEvent('bottomPanel', { id: 'removeLink' });
                                                    setShowRemoveLinkConfirm(false);
                                                    setActiveLink(null);
                                                } })] })] }), _jsx("div", { className: "footerImageHolder", style: { backgroundImage: 'url(./assets/images/shareColourPatches.svg)' } })] }) }) }), _jsx(ContextMenu, {})] }));
};
export default WhiteBoard;
